var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _rect, _path918, _path919, _path920, _path921, _path922, _rect2, _path923, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductIllustrator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 463,
    viewBox: "0 0 480 463",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M238.696 188.63C254.877 197.965 281.147 197.965 297.328 188.63C313.541 179.262 313.541 164.096 297.328 154.761C281.114 145.426 254.877 145.426 238.663 154.761C222.45 164.129 222.45 179.262 238.663 188.63H238.696Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M283.963 128.234L267.454 118.736L299.456 100.262L327.101 116.082L341.743 107.632L456.942 174.124L408.923 201.835L335.487 159.45L320.845 167.901L267.979 137.471L283.963 128.234Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M436.576 115.456L317.216 46.54L312.139 55.6786L312.172 101.536L441.686 176.315L441.653 130.458L436.576 115.456Z",
    fill: "url(#paint0_linear_1504_151244)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 113.884L436.576 115.456L441.653 130.458L444.372 128.918L439.295 113.884Z",
    fill: "#FFA500"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 113.884L436.576 115.456L441.653 130.458L444.372 128.918L439.295 113.884Z",
    fill: "url(#paint1_linear_1504_151244)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M439.288 113.884L319.929 45L317.21 46.5395L436.569 115.456L439.288 113.884Z",
    fill: "url(#paint2_linear_1504_151244)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M444.364 128.916L411.412 147.914L411.445 193.771L444.396 174.74L444.364 128.916Z",
    fill: "#FFA500"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M444.364 128.916L411.412 147.914L411.445 193.771L444.396 174.74L444.364 128.916Z",
    fill: "url(#paint3_linear_1504_151244)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M417.169 114.475V116.048L403.511 108.154V99.6045L404.559 100.227V107.204L417.169 114.475Z",
    fill: "#344054"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M417.169 107.505V114.482L404.559 107.21V100.233L417.169 107.505Z",
    fill: "#9D430A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M436.263 127.055L420.246 117.819V109.27L421.294 109.859V116.869L435.51 125.057L436.263 127.055Z",
    fill: "#344054"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M435.51 125.058L421.294 116.869V109.859L432.071 116.083L435.51 125.058Z",
    fill: "#9D430A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M333.407 66.1312V67.6707L317.423 58.4338L321.583 52.3086L321.878 52.4724L318.471 57.4839L333.407 66.1312Z",
    fill: "#344054"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M333.407 59.1239V66.1334L318.471 57.4861L321.878 52.4746L333.407 59.1239Z",
    fill: "#9D430A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M400.432 104.816V106.388L386.773 98.4943V89.9453L387.822 90.5677V97.5444L400.432 104.816Z",
    fill: "#344054"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M400.432 97.837V104.814L387.821 97.5422V90.5654L400.432 97.837Z",
    fill: "#9D430A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M383.719 95.1491V96.7213L370.028 88.8274V80.2783L371.076 80.9007V87.8775L383.719 95.1491Z",
    fill: "#344054"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M383.719 88.174V95.1508L371.076 87.8792V80.9023L383.719 88.174Z",
    fill: "#9D430A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M366.987 85.5198V87.0593L353.295 79.1653V70.6162L354.343 71.2386V78.2154L366.987 85.5198Z",
    fill: "#344054"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M366.987 78.5118V85.5215L354.343 78.2171V71.2402L366.987 78.5118Z",
    fill: "#9D430A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M350.25 75.8615V77.401L336.591 69.507V60.958L337.606 61.5804V68.5572L350.25 75.8615Z",
    fill: "#344054"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M350.25 68.8507V75.8602L337.606 68.5559V61.5791L350.25 68.8507Z",
    fill: "#9D430A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M303.742 48.4043C303.742 48.4043 303.84 48.3388 303.906 48.3061C304.594 47.9458 305.511 48.044 306.493 48.6009L352.776 75.3289L445.801 129.047C445.801 129.047 446.063 129.211 446.194 129.309C448.093 130.652 449.6 133.371 449.6 135.631V135.991C449.6 137.203 449.174 138.022 448.487 138.448L425.689 151.615L281.141 61.4736L303.742 48.4043Z",
    fill: "url(#paint4_linear_1504_151244)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M280.752 64.3542V64.7145C280.752 66.647 282.127 69.0054 283.798 69.9881L423.105 150.401C424.088 150.958 424.939 150.926 425.496 150.401C425.07 150.401 424.579 150.303 424.055 150.008L284.748 69.5623C283.077 68.6124 281.701 66.2212 281.701 64.3214V63.9611C281.701 63.175 281.931 62.5527 282.324 62.1924C281.374 62.2579 280.719 63.044 280.719 64.3542H280.752Z",
    fill: "#212121"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M281.734 63.9607V64.321C281.734 66.2536 283.11 68.6119 284.78 69.5618L424.088 150.008C424.612 150.303 425.103 150.434 425.529 150.401C425.922 150.041 426.151 149.418 426.151 148.632V148.272C426.151 146.34 424.775 143.981 423.105 142.998L283.798 62.585C283.274 62.2902 282.782 62.1592 282.356 62.1592C281.963 62.5195 281.734 63.1091 281.734 63.928V63.9607Z",
    fill: "#878787"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M283.799 62.5851C282.129 61.6353 280.753 62.4214 280.753 64.3212V64.6814C280.753 66.614 282.129 68.9724 283.799 69.955L423.107 150.368C424.777 151.318 426.153 150.565 426.153 148.632V148.272C426.153 146.34 424.777 143.981 423.107 142.999L283.799 62.5851ZM283.799 61.7007L423.107 142.147C425.203 143.359 426.906 146.307 426.906 148.731V149.091C426.906 151.515 425.203 152.497 423.107 151.286L283.799 70.8394C281.703 69.6274 280 66.6795 280 64.2557V63.8953C280 61.4715 281.703 60.4888 283.799 61.7007Z",
    fill: "#363636"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M355.14 76.7052L353.633 75.8535L330.934 88.9228L332.44 89.8072L355.14 76.7052Z",
    fill: "#363636"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M361.187 80.211L359.68 79.3594L337.014 92.4286L338.52 93.313L361.187 80.211Z",
    fill: "#363636"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M367.255 83.7129L365.782 82.8613L343.082 95.9305L344.589 96.8149L367.255 83.7129Z",
    fill: "#363636"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M373.351 87.2197L371.844 86.3682L349.145 99.4702L350.652 100.322L373.351 87.2197Z",
    fill: "#363636"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M379.41 90.7179L377.903 89.8662L355.237 102.968L356.743 103.82L379.41 90.7179Z",
    fill: "#363636"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M385.498 94.2276L383.991 93.376L361.292 106.478L362.799 107.33L385.498 94.2276Z",
    fill: "#363636"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M391.56 97.7305L390.053 96.8789L367.386 109.981L368.86 110.832L391.56 97.7305Z",
    fill: "#363636"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M397.614 101.239L396.14 100.388L373.441 113.49L374.948 114.341L397.614 101.239Z",
    fill: "#363636"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M403.707 104.744L402.2 103.893L379.501 116.995L381.008 117.846L403.707 104.744Z",
    fill: "#363636"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M312.615 52.1716L311.108 51.2871L288.441 64.3891L289.948 65.2735L312.615 52.1716Z",
    fill: "#363636"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M318.674 55.6729L317.167 54.8213L294.5 67.8905L296.007 68.7748L318.674 55.6729Z",
    fill: "#363636"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M324.769 59.1847L323.262 58.333L300.563 71.4023L302.07 72.2867L324.769 59.1847Z",
    fill: "#363636"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M330.833 62.69L329.327 61.8057L306.66 74.9077L308.167 75.792L330.833 62.69Z",
    fill: "#363636"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M336.924 66.1915L335.417 65.3398L312.718 78.409L314.224 79.2935L336.924 66.1915Z",
    fill: "#363636"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M342.983 69.6943L341.476 68.8428L318.81 81.912L320.284 82.7963L342.983 69.6943Z",
    fill: "#363636"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M349.042 73.2022L347.535 72.3506L324.869 85.4199L326.375 86.3042L349.042 73.2022Z",
    fill: "#363636"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M409.771 108.247L408.264 107.396L385.598 120.497L387.104 121.349L409.771 108.247Z",
    fill: "#363636"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M415.854 111.756L414.348 110.904L391.648 124.006L393.155 124.858L415.854 111.756Z",
    fill: "#363636"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M421.933 115.256L420.426 114.404L397.759 127.506L399.233 128.358L421.933 115.256Z",
    fill: "#363636"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M427.987 118.76L426.513 117.908L403.813 131.01L405.32 131.862L427.987 118.76Z",
    fill: "#363636"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M434.078 122.267L432.571 121.415L409.872 134.517L411.378 135.369L434.078 122.267Z",
    fill: "#363636"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M440.139 125.772L438.632 124.92L415.966 138.022L417.472 138.874L440.139 125.772Z",
    fill: "#363636"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M446.198 129.312L444.724 128.428L422.025 141.53L423.531 142.381L446.198 129.312Z",
    fill: "#363636"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M414.52 140.576L415.404 140.118C415.764 139.954 416.255 140.02 416.779 140.314C417.925 140.969 418.875 142.607 418.875 143.917C418.875 144.604 418.613 145.096 418.187 145.292L417.565 145.587L417.434 145.358C417.238 145.325 417.009 145.227 416.779 145.096C415.633 144.441 414.683 142.803 414.683 141.493C414.683 141.297 414.683 141.1 414.749 140.969L414.52 140.576Z",
    fill: "#A6A6A6"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M414.036 141.856C414.036 143.199 414.953 144.803 416.132 145.458C417.278 146.113 418.228 145.589 418.228 144.247C418.228 142.904 417.278 141.299 416.132 140.644C414.986 139.989 414.036 140.513 414.036 141.856Z",
    fill: "#5C5C5C"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M415.08 142.476C415.08 143.131 415.539 143.949 416.128 144.277C416.521 144.506 416.881 144.44 417.045 144.178C416.914 144.178 416.783 144.113 416.619 144.047C416.03 143.72 415.571 142.902 415.571 142.247C415.571 142.018 415.604 141.854 415.702 141.756C415.342 141.756 415.08 142.018 415.08 142.509V142.476Z",
    fill: "#A6A6A6"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M415.57 142.219C415.57 142.873 416.028 143.692 416.617 144.019C416.781 144.117 416.912 144.15 417.043 144.15C417.108 144.019 417.174 143.855 417.174 143.659C417.174 143.004 416.716 142.186 416.126 141.858C415.963 141.76 415.832 141.728 415.701 141.728C415.603 141.858 415.57 142.022 415.57 142.219Z",
    fill: "#4A4A4A"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M402.396 133.571L403.281 133.112C403.641 132.948 404.132 133.014 404.656 133.309C405.802 133.964 406.752 135.601 406.752 136.911C406.752 137.631 406.49 138.09 406.064 138.286L405.442 138.581L405.311 138.352C405.114 138.319 404.885 138.221 404.656 138.09C403.51 137.435 402.56 135.797 402.56 134.487C402.56 134.291 402.56 134.127 402.626 133.964L402.396 133.571Z",
    fill: "#A6A6A6"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M401.868 134.85C401.868 136.193 402.818 137.797 403.964 138.452C405.11 139.107 406.06 138.583 406.06 137.241C406.06 135.898 405.11 134.294 403.964 133.639C402.818 132.984 401.868 133.508 401.868 134.85Z",
    fill: "#5C5C5C"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M402.93 135.471C402.93 136.126 403.388 136.944 403.977 137.272C404.37 137.501 404.73 137.435 404.894 137.173C404.763 137.173 404.632 137.108 404.469 137.042C403.879 136.715 403.421 135.897 403.421 135.242C403.421 135.046 403.454 134.849 403.552 134.751C403.192 134.751 402.93 135.013 402.93 135.504V135.471Z",
    fill: "#A6A6A6"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M403.405 135.214C403.405 135.868 403.863 136.687 404.453 137.014C404.616 137.112 404.747 137.145 404.878 137.145C404.944 137.014 405.009 136.851 405.009 136.654C405.009 135.999 404.551 135.181 403.961 134.854C403.798 134.755 403.667 134.723 403.536 134.723C403.47 134.854 403.405 135.017 403.405 135.214Z",
    fill: "#4A4A4A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M391.76 127.445L392.644 126.986C393.005 126.822 393.496 126.888 394.02 127.183C395.166 127.838 396.116 129.475 396.116 130.785C396.116 131.505 395.854 131.964 395.428 132.16L394.806 132.455L394.675 132.226C394.478 132.193 394.249 132.095 394.02 131.964C392.874 131.276 391.924 129.671 391.924 128.361C391.924 128.165 391.924 127.969 391.989 127.838L391.76 127.445Z",
    fill: "#A6A6A6"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M391.276 128.725C391.276 130.068 392.226 131.672 393.372 132.327C394.518 132.982 395.468 132.458 395.468 131.116C395.468 129.773 394.518 128.169 393.372 127.514C392.226 126.859 391.276 127.383 391.276 128.725Z",
    fill: "#5C5C5C"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M392.321 129.314C392.321 129.969 392.779 130.787 393.368 131.114C393.761 131.344 394.121 131.278 394.285 131.016C394.154 131.016 393.99 130.951 393.859 130.885C393.27 130.558 392.812 129.74 392.812 129.085C392.812 128.888 392.844 128.692 392.943 128.594C392.583 128.594 392.321 128.856 392.321 129.347V129.314Z",
    fill: "#A6A6A6"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M392.769 129.085C392.769 129.74 393.227 130.558 393.816 130.885C393.98 130.984 394.111 131.016 394.242 131.016C394.307 130.885 394.373 130.722 394.373 130.525C394.373 129.87 393.915 129.052 393.325 128.725C393.162 128.627 393.031 128.594 392.9 128.594C392.802 128.725 392.769 128.888 392.769 129.085Z",
    fill: "#4A4A4A"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M381.143 121.316L382.027 120.857C382.387 120.694 382.878 120.759 383.402 121.054C384.548 121.709 385.498 123.346 385.498 124.656C385.498 125.344 385.236 125.835 384.81 126.031L384.221 126.326L384.09 126.097C383.893 126.064 383.664 125.966 383.435 125.835C382.289 125.18 381.339 123.542 381.339 122.2C381.339 122.003 381.339 121.84 381.405 121.676L381.143 121.283V121.316Z",
    fill: "#A6A6A6"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M380.659 122.596C380.659 123.939 381.576 125.544 382.755 126.198C383.901 126.853 384.851 126.329 384.851 124.987C384.851 123.644 383.901 122.04 382.755 121.385C381.609 120.73 380.659 121.254 380.659 122.596Z",
    fill: "#5C5C5C"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M381.679 123.185C381.679 123.84 382.137 124.658 382.726 124.986C383.119 125.215 383.479 125.149 383.643 124.887C383.512 124.887 383.348 124.855 383.217 124.756C382.628 124.429 382.17 123.611 382.17 122.956C382.17 122.759 382.203 122.563 382.301 122.465C381.941 122.465 381.712 122.727 381.712 123.218L381.679 123.185Z",
    fill: "#A6A6A6"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M382.152 122.956C382.152 123.611 382.61 124.429 383.199 124.756C383.363 124.855 383.494 124.887 383.625 124.887C383.723 124.756 383.756 124.593 383.756 124.396C383.756 123.742 383.297 122.923 382.708 122.596C382.544 122.498 382.413 122.465 382.282 122.465C382.217 122.596 382.152 122.759 382.152 122.956Z",
    fill: "#4A4A4A"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M370.491 115.192L371.375 114.734C371.736 114.57 372.227 114.603 372.751 114.93C373.897 115.585 374.847 117.223 374.847 118.533C374.847 119.253 374.585 119.711 374.159 119.908L373.569 120.203L373.438 119.973C373.242 119.941 373.013 119.842 372.784 119.711C371.637 119.057 370.688 117.419 370.688 116.109C370.688 115.913 370.688 115.716 370.753 115.553L370.524 115.16L370.491 115.192Z",
    fill: "#A6A6A6"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M370.01 116.437C370.01 117.78 370.959 119.384 372.105 120.039C373.252 120.694 374.201 120.17 374.201 118.828C374.201 117.485 373.284 115.88 372.105 115.225C370.959 114.571 370.01 115.094 370.01 116.437Z",
    fill: "#5C5C5C"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M371.052 117.061C371.052 117.716 371.51 118.534 372.099 118.861C372.492 119.091 372.852 119.025 373.016 118.763C372.885 118.763 372.721 118.698 372.59 118.632C372.001 118.305 371.543 117.487 371.543 116.832C371.543 116.635 371.575 116.439 371.674 116.341C371.314 116.341 371.052 116.603 371.052 117.094V117.061Z",
    fill: "#A6A6A6"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M371.537 116.798C371.537 117.452 371.995 118.271 372.584 118.598C372.748 118.696 372.879 118.729 373.01 118.729C373.075 118.598 373.141 118.434 373.141 118.238C373.141 117.583 372.682 116.765 372.093 116.438C371.929 116.339 371.798 116.307 371.667 116.307C371.602 116.438 371.537 116.601 371.537 116.798Z",
    fill: "#4A4A4A"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M359.874 109.037L360.758 108.579C361.119 108.415 361.61 108.448 362.134 108.775C363.28 109.43 364.23 111.067 364.23 112.377C364.23 113.098 363.968 113.556 363.542 113.753L362.952 114.047L362.821 113.818C362.625 113.785 362.396 113.687 362.167 113.556C361.02 112.868 360.071 111.264 360.071 109.954C360.071 109.757 360.071 109.594 360.136 109.43L359.874 109.037Z",
    fill: "#A6A6A6"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M359.39 110.316C359.39 111.659 360.34 113.263 361.486 113.918C362.632 114.573 363.582 114.049 363.582 112.707C363.582 111.364 362.665 109.759 361.486 109.104C360.34 108.449 359.39 108.973 359.39 110.316Z",
    fill: "#5C5C5C"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M360.435 110.906C360.435 111.56 360.893 112.379 361.482 112.706C361.875 112.935 362.235 112.87 362.399 112.608C362.268 112.608 362.104 112.543 361.973 112.477C361.384 112.15 360.926 111.331 360.926 110.677C360.926 110.48 360.958 110.284 361.057 110.186C360.696 110.186 360.435 110.447 360.435 110.939V110.906Z",
    fill: "#A6A6A6"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M360.883 110.677C360.883 111.331 361.341 112.15 361.931 112.477C362.094 112.575 362.225 112.608 362.356 112.608C362.422 112.477 362.487 112.313 362.487 112.117C362.487 111.462 362.029 110.644 361.44 110.317C361.276 110.218 361.145 110.186 361.014 110.186C360.916 110.316 360.883 110.48 360.883 110.677Z",
    fill: "#4A4A4A"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M349.23 102.911L350.114 102.453C350.475 102.289 350.966 102.355 351.49 102.649C352.636 103.304 353.586 104.942 353.586 106.252C353.586 106.972 353.324 107.431 352.898 107.627L352.308 107.922L352.177 107.693C351.981 107.66 351.752 107.562 351.522 107.431C350.376 106.776 349.427 105.138 349.427 103.828C349.427 103.632 349.427 103.435 349.492 103.272L349.23 102.879V102.911Z",
    fill: "#A6A6A6"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M348.744 104.185C348.744 105.528 349.661 107.132 350.839 107.787C351.986 108.442 352.935 107.918 352.935 106.575C352.935 105.233 351.986 103.628 350.839 102.973C349.693 102.286 348.744 102.842 348.744 104.185Z",
    fill: "#5C5C5C"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M349.79 104.784C349.79 105.438 350.249 106.257 350.838 106.584C351.231 106.813 351.591 106.748 351.755 106.486C351.624 106.486 351.493 106.42 351.329 106.355C350.74 106.028 350.282 105.209 350.282 104.555C350.282 104.358 350.314 104.162 350.412 104.063C350.052 104.063 349.79 104.325 349.79 104.816V104.784Z",
    fill: "#A6A6A6"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M350.276 104.555C350.276 105.209 350.734 106.028 351.323 106.355C351.487 106.453 351.618 106.486 351.749 106.486C351.847 106.355 351.88 106.191 351.88 105.995C351.88 105.34 351.421 104.522 350.832 104.194C350.668 104.096 350.537 104.063 350.407 104.063C350.308 104.194 350.276 104.358 350.276 104.555Z",
    fill: "#4A4A4A"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M338.634 96.7509L339.518 96.2924C339.878 96.1287 340.369 96.1614 340.893 96.4889C342.039 97.1439 342.989 98.7811 342.989 100.091C342.989 100.811 342.727 101.27 342.301 101.466L341.712 101.761L341.581 101.532C341.384 101.499 341.155 101.401 340.926 101.27C339.78 100.615 338.83 98.9777 338.83 97.6678C338.83 97.4713 338.83 97.2748 338.895 97.1438L338.634 96.7509Z",
    fill: "#A6A6A6"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M338.15 98.03C338.15 99.3726 339.067 100.977 340.245 101.632C341.392 102.287 342.341 101.763 342.341 100.42C342.341 99.0778 341.424 97.4732 340.245 96.8182C339.099 96.1633 338.15 96.6873 338.15 98.03Z",
    fill: "#5C5C5C"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M339.194 98.6528C339.194 99.3075 339.652 100.126 340.242 100.453C340.635 100.682 340.995 100.617 341.158 100.355C341.027 100.355 340.864 100.322 340.733 100.224C340.143 99.8967 339.685 99.0784 339.685 98.4236C339.685 98.2272 339.718 98.0308 339.816 97.9326C339.456 97.9326 339.194 98.1944 339.194 98.6855V98.6528Z",
    fill: "#A6A6A6"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M339.642 98.3865C339.642 99.0413 340.1 99.8596 340.69 100.187C340.853 100.285 340.984 100.318 341.115 100.318C341.213 100.187 341.246 100.023 341.246 99.8269C341.246 99.1395 340.788 98.3538 340.199 98.0265C340.035 97.9283 339.904 97.8955 339.773 97.8955C339.675 98.0265 339.642 98.1901 339.642 98.3865Z",
    fill: "#4A4A4A"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M328.017 90.6302L328.902 90.1717C329.262 90.008 329.753 90.0735 330.277 90.3682C331.423 91.0231 332.373 92.6605 332.373 93.9704C332.373 94.6908 332.111 95.1493 331.685 95.3458L331.096 95.6405L330.965 95.4113C330.768 95.3785 330.539 95.2803 330.31 95.1493C329.164 94.4616 328.214 92.857 328.214 91.5471C328.214 91.3506 328.214 91.1541 328.279 91.0232L328.017 90.6302Z",
    fill: "#A6A6A6"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M327.49 91.9093C327.49 93.2519 328.407 94.8565 329.585 95.5115C330.732 96.1664 331.681 95.6425 331.681 94.2998C331.681 92.9572 330.732 91.3526 329.585 90.6649C328.439 90.01 327.49 90.5339 327.49 91.8766V91.9093Z",
    fill: "#5C5C5C"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M328.553 92.4995C328.553 93.1542 329.012 93.9726 329.601 94.3C329.994 94.5291 330.354 94.4636 330.518 94.2018C330.387 94.2018 330.223 94.1363 330.092 94.0708C329.503 93.7434 329.045 92.925 329.045 92.2703C329.045 92.0739 329.077 91.8775 329.175 91.7793C328.815 91.7793 328.553 92.0411 328.553 92.5322V92.4995Z",
    fill: "#A6A6A6"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M329.026 92.2703C329.026 92.925 329.484 93.7434 330.073 94.0708C330.237 94.169 330.368 94.2018 330.499 94.2018C330.565 94.0708 330.63 93.9071 330.63 93.7107C330.63 93.056 330.172 92.2375 329.582 91.9102C329.419 91.812 329.288 91.7793 329.157 91.7793C329.059 91.9102 329.026 92.0739 329.026 92.2703Z",
    fill: "#4A4A4A"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M317.37 84.5033L318.255 84.0447C318.615 83.881 319.106 83.9465 319.63 84.2412C320.776 84.8962 321.726 86.5335 321.726 87.8434C321.726 88.5639 321.464 89.0224 321.038 89.2189L320.416 89.5136L320.285 89.2843C320.088 89.2516 319.859 89.1534 319.63 89.0224C318.484 88.3674 317.534 86.7301 317.534 85.4202C317.534 85.2237 317.534 85.0272 317.6 84.8962L317.338 84.5033H317.37Z",
    fill: "#A6A6A6"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M316.886 85.7838C316.886 87.1264 317.803 88.7311 318.982 89.386C320.128 90.0409 321.078 89.517 321.078 88.1744C321.078 86.8317 320.128 85.2271 318.982 84.5722C317.836 83.9172 316.886 84.4412 316.886 85.7838Z",
    fill: "#5C5C5C"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M317.906 86.3755C317.906 87.0302 318.365 87.8486 318.954 88.1759C319.347 88.4051 319.707 88.3396 319.871 88.0777C319.74 88.0777 319.576 88.0122 319.445 87.9468C318.856 87.6194 318.397 86.801 318.397 86.1463C318.397 85.9171 318.43 85.7535 318.528 85.6553C318.168 85.6553 317.906 85.9171 317.906 86.4081V86.3755Z",
    fill: "#A6A6A6"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M318.379 86.1463C318.379 86.801 318.837 87.6194 319.426 87.9468C319.59 88.045 319.721 88.0777 319.852 88.0777C319.917 87.9468 319.983 87.7831 319.983 87.5867C319.983 86.932 319.525 86.1135 318.935 85.7861C318.772 85.6879 318.641 85.6553 318.51 85.6553C318.412 85.7862 318.379 85.9499 318.379 86.1463Z",
    fill: "#4A4A4A"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M306.749 78.346L307.633 77.8875C307.993 77.7238 308.485 77.7893 309.009 78.084C310.155 78.7389 311.104 80.3763 311.104 81.6862C311.104 82.4066 310.842 82.8651 310.417 83.0616L309.827 83.3563L309.696 83.1271C309.5 83.0943 309.271 82.9961 309.041 82.8652C307.895 82.2102 306.945 80.5728 306.945 79.2629C306.945 79.0665 306.945 78.9027 307.011 78.739L306.782 78.346H306.749Z",
    fill: "#A6A6A6"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M306.221 79.6266C306.221 80.9692 307.171 82.5738 308.317 83.2288C309.463 83.8837 310.413 83.3598 310.413 82.0171C310.413 80.6745 309.496 79.0699 308.317 78.4149C307.171 77.76 306.221 78.2839 306.221 79.6266Z",
    fill: "#5C5C5C"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M307.285 80.2466C307.285 80.9013 307.743 81.7198 308.332 82.0471C308.725 82.2763 309.053 82.2108 309.249 81.9489C309.118 81.9489 308.954 81.8834 308.823 81.818C308.234 81.4906 307.776 80.6722 307.776 80.0175C307.776 79.8211 307.809 79.6246 307.907 79.5264C307.547 79.5264 307.285 79.7883 307.285 80.2793V80.2466Z",
    fill: "#A6A6A6"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M307.757 79.9891C307.757 80.6438 308.216 81.4622 308.805 81.7895C308.969 81.8877 309.1 81.9205 309.231 81.9205C309.296 81.7896 309.362 81.6259 309.362 81.4295C309.362 80.7748 308.903 79.9563 308.314 79.6289C308.15 79.5307 308.019 79.498 307.888 79.498C307.79 79.629 307.757 79.7927 307.757 79.9891Z",
    fill: "#4A4A4A"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M296.115 72.2122L296.999 71.7537C297.359 71.59 297.85 71.6555 298.374 71.9502C299.521 72.6052 300.47 74.2425 300.47 75.5524C300.47 76.2728 300.208 76.7314 299.783 76.9278L299.193 77.2225L299.062 76.9933C298.866 76.9605 298.636 76.8623 298.407 76.7314C297.261 76.0437 296.311 74.439 296.311 73.1292C296.311 72.9327 296.311 72.7361 296.377 72.5724L296.115 72.1795V72.2122Z",
    fill: "#A6A6A6"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M295.631 73.4923C295.631 74.835 296.581 76.4396 297.727 77.0945C298.873 77.7495 299.823 77.2255 299.823 75.8829C299.823 74.5403 298.873 72.9356 297.727 72.2479C296.581 71.593 295.631 72.117 295.631 73.4597V73.4923Z",
    fill: "#5C5C5C"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M296.675 74.0835C296.675 74.7382 297.134 75.5566 297.723 75.8839C298.116 76.1131 298.476 76.0476 298.64 75.7857C298.509 75.7857 298.345 75.7202 298.214 75.6548C297.625 75.3274 297.166 74.509 297.166 73.8543C297.166 73.6579 297.199 73.4615 297.297 73.3633C296.937 73.3633 296.675 73.6251 296.675 74.1162V74.0835Z",
    fill: "#A6A6A6"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M297.123 73.8543C297.123 74.509 297.582 75.3274 298.171 75.6548C298.335 75.753 298.465 75.7857 298.596 75.7857C298.662 75.6548 298.727 75.4911 298.727 75.2947C298.727 74.64 298.269 73.8215 297.68 73.4942C297.516 73.3959 297.385 73.3633 297.254 73.3633C297.189 73.4942 297.123 73.6579 297.123 73.8543Z",
    fill: "#4A4A4A"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M285.499 66.0872L286.383 65.6287C286.744 65.465 287.235 65.5305 287.759 65.8252C288.905 66.4802 289.854 68.1175 289.854 69.4274C289.854 70.1478 289.593 70.6064 289.167 70.8028L288.577 71.0975L288.446 70.8683C288.25 70.8355 288.021 70.7372 287.791 70.6063C286.645 69.9513 285.696 68.314 285.696 67.0042C285.696 66.8077 285.696 66.6439 285.761 66.4802L285.499 66.0872Z",
    fill: "#A6A6A6"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M284.971 67.3664C284.971 68.709 285.921 70.3136 287.067 70.9686C288.213 71.6235 289.163 71.0996 289.163 69.757C289.163 68.4143 288.213 66.8097 287.067 66.122C285.921 65.467 284.971 65.991 284.971 67.3336V67.3664Z",
    fill: "#5C5C5C"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M286.035 67.9482C286.035 68.6029 286.493 69.4214 287.082 69.7487C287.475 69.9779 287.835 69.9124 287.999 69.6505C287.868 69.6505 287.737 69.585 287.573 69.4868C286.984 69.1594 286.526 68.3411 286.526 67.6863C286.526 67.4899 286.559 67.2935 286.657 67.1953C286.297 67.1953 286.035 67.4571 286.035 67.9482Z",
    fill: "#A6A6A6"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M286.507 67.725C286.507 68.3797 286.966 69.1981 287.555 69.5254C287.719 69.6236 287.85 69.6563 287.981 69.6891C288.079 69.5581 288.112 69.3945 288.112 69.198C288.112 68.5433 287.653 67.7249 287.064 67.3976C286.9 67.2994 286.769 67.2666 286.638 67.2666C286.573 67.3975 286.507 67.5612 286.507 67.7576V67.725Z",
    fill: "#4A4A4A"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M406.333 132.916L287.006 63.999L281.896 73.1377V118.995L411.443 193.774L411.41 147.917L406.333 132.916Z",
    fill: "url(#paint5_linear_1504_151244)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M386.628 132.196V133.735L372.936 125.841V117.292L373.984 117.914V124.891L386.628 132.196Z",
    fill: "#344054"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M386.628 125.19V132.199L373.984 124.895V117.918L386.628 125.19Z",
    fill: "url(#paint6_linear_1504_151244)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M405.689 144.741L389.672 135.504V126.955L390.72 127.577V134.554L404.936 142.776L405.689 144.741Z",
    fill: "#344054"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M404.937 142.773L390.721 134.552V127.575L401.497 133.799L404.937 142.773Z",
    fill: "url(#paint7_linear_1504_151244)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M302.836 83.8166V85.3561L286.852 76.1193L291.045 69.9941L291.339 70.1907L287.9 75.2022L302.836 83.8166Z",
    fill: "#344054"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M302.837 76.8377V83.8145L287.9 75.2L291.34 70.1885L302.837 76.8377Z",
    fill: "url(#paint8_linear_1504_151244)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M369.888 122.535V124.075L356.196 116.181V107.632L357.244 108.254V115.264L369.888 122.535Z",
    fill: "#344054"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M369.888 115.523V122.532L357.244 115.26V108.251L369.888 115.523Z",
    fill: "url(#paint9_linear_1504_151244)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M353.148 112.867V114.407L339.489 106.513V97.9639L340.537 98.5862V105.596L353.148 112.867Z",
    fill: "#344054"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M353.148 105.862V112.872L340.537 105.6V98.5908L353.148 105.862Z",
    fill: "url(#paint10_linear_1504_151244)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M336.413 103.206V104.745L322.755 96.8513V88.335L323.803 88.9246V95.9014L336.413 103.206Z",
    fill: "#344054"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M336.413 96.1974V103.207L323.803 95.9025V88.9258L336.413 96.1974Z",
    fill: "url(#paint11_linear_1504_151244)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M319.676 93.5474V95.0869L306.017 87.1931V78.6768L307.065 79.2663V86.2431L319.676 93.5474Z",
    fill: "#344054"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M319.676 86.5363V93.5458L307.065 86.2415V79.2646L319.676 86.5363Z",
    fill: "url(#paint12_linear_1504_151244)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M409.047 131.343L406.328 132.915L411.405 147.917L414.124 146.345L409.047 131.343Z",
    fill: "url(#paint13_linear_1504_151244)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M409.042 131.343L289.683 62.459L286.997 63.9985L406.324 132.915L409.042 131.343Z",
    fill: "url(#paint14_linear_1504_151244)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M330.82 64.7267L367.964 86.1485V44.1239L330.82 22.7021V64.7267Z",
    fill: "#FF8800"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M330.82 64.7267L367.964 86.1485V44.1239L330.82 22.7021V64.7267Z",
    fill: "#7A2E0E"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M330.82 64.7267L367.964 86.1485V44.1239L330.82 22.7021V64.7267Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M284.238 78.2839L293.017 37.0126L334.517 13.167L372.251 34.9163L335.041 60.1048L321.972 100.066V161.58L284.238 139.798V95.7422L270.022 94.3666V86.4726L284.238 78.2839Z",
    fill: "url(#paint15_linear_1504_151244)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M284.238 78.2839L293.017 37.0126L334.517 13.167L372.251 34.9163L335.041 60.1048L321.972 100.066V161.58L284.238 139.798V95.7422L270.022 94.3666V86.4726L284.238 78.2839Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M291.82 74.752L316.288 88.9021L316.714 86.9041L294.31 73.9331L299.583 49.1703L297.52 47.9912L291.82 74.752Z",
    fill: "#7A2E0E"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M294.305 73.9288C299.907 81.1349 316.71 86.867 316.71 86.867L321.983 62.1043L299.579 49.166C299.579 49.166 293.781 60.532 294.305 73.9288Z",
    fill: "#0D0D0D"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M303.148 56.4784L319.198 65.748L319.493 64.2413L303.476 54.9717L303.148 56.4784Z",
    fill: "#75C425"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M302.323 60.1399L318.373 69.4096L318.701 67.9356L302.651 58.666L302.323 60.1399Z",
    fill: "#75C425"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M299.255 75.1112L315.272 84.3481L315.6 82.8741L299.55 73.6045L299.255 75.1112Z",
    fill: "#75C425"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M299.741 71.9042L315.758 81.1739L317.068 74.4591L301.018 65.1895L299.741 71.9042Z",
    fill: "#75C425"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M307.404 66.958L317.525 72.7884L317.853 71.3143L307.699 65.4512L307.404 66.958Z",
    fill: "#75C425"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M270.021 86.4768L307.722 108.259L321.971 100.07L284.237 78.2881L270.021 86.4768Z",
    fill: "url(#paint16_linear_1504_151244)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M291.146 83.3312L283.547 87.7203L281.45 86.5084L289.049 82.1191L291.146 83.3312Z",
    fill: "black"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M288.208 81.6279L280.609 86.0171L278.512 84.8052L286.112 80.416L288.208 81.6279Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M282.195 82.377L287.698 85.5869L289.794 84.375V83.163L282.195 81.165V82.377Z",
    fill: "#A62626"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M282.195 81.168L287.698 84.3452L289.794 83.166L284.258 79.9561L282.195 81.168Z",
    fill: "#D63A3A"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M313.717 100.685L315.846 99.4729L313.717 98.2285L311.589 99.4729L313.717 100.685Z",
    fill: "#1C4B94"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M310.061 98.5928L312.19 97.3484L310.061 96.1367L307.933 97.3484L310.061 98.5928Z",
    fill: "#D63A3A"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M306.441 96.4961L308.57 95.2844L306.441 94.04L304.313 95.2844L306.441 96.4961Z",
    fill: "#1C4B94"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M310.152 102.75L312.28 101.538L310.152 100.294L308.023 101.538L310.152 102.75Z",
    fill: "#D63A3A"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M306.478 100.652L308.607 99.4079L306.478 98.1963L304.35 99.4079L306.478 100.652Z",
    fill: "#1C4B94"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M302.873 98.5625L305.002 97.3509L302.873 96.1064L300.744 97.3509L302.873 98.5625Z",
    fill: "#D63A3A"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M306.517 104.851L308.646 103.639L306.517 102.395L304.389 103.639L306.517 104.851Z",
    fill: "#D63A3A"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M302.846 102.75L304.974 101.506L302.846 100.294L300.717 101.506L302.846 102.75Z",
    fill: "#25A4C4"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M299.248 100.652L301.377 99.4407L299.248 98.1963L297.12 99.4407L299.248 100.652Z",
    fill: "#1C4B94"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M300.643 93.1562L302.772 91.9118L300.643 90.7002L298.515 91.9118L300.643 93.1562Z",
    fill: "#1C4B94"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M296.985 91.0322L299.113 89.8206L296.985 88.5762L294.856 89.8206L296.985 91.0322Z",
    fill: "#D63A3A"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M293.367 88.933L295.496 87.7214L293.367 86.5098L291.239 87.7214L293.367 88.933Z",
    fill: "#1C4B94"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M297.078 95.2197L299.206 93.9754L297.078 92.7637L294.949 93.9754L297.078 95.2197Z",
    fill: "#D63A3A"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M293.407 93.0937L295.535 91.8821L293.407 90.6377L291.278 91.8821L293.407 93.0937Z",
    fill: "#1C4B94"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M289.799 90.9931L291.928 89.7815L289.799 88.5371L287.67 89.7815L289.799 90.9931Z",
    fill: "#D63A3A"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M293.443 97.3213L295.572 96.0769L293.443 94.8652L291.347 96.0769L293.443 97.3213Z",
    fill: "#D63A3A"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M289.772 95.1875L291.901 93.9759L289.772 92.7314L287.676 93.9759L289.772 95.1875Z",
    fill: "#25A4C4"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M286.172 93.0902L288.301 91.8786L286.172 90.667L284.044 91.8786L286.172 93.0902Z",
    fill: "#1C4B94"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M321.972 100.067L330.718 58.7953L372.251 34.917V75.4676L369.5 77.0398V85.2941L367.96 86.1457V45.333L343.656 59.3849V93.8759L341.92 92.8932L338.874 94.6292V151.819L321.972 161.58V117.492L307.724 116.116V108.255L321.972 100.067Z",
    fill: "url(#paint17_linear_1504_151244)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M270.028 94.3686L307.729 116.118V108.257L270.028 86.4746V94.3686Z",
    fill: "url(#paint18_linear_1504_151244)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M359.693 84.6339L344.691 75.9538L360.152 67.0771L375.186 75.7245L359.693 84.6339Z",
    fill: "#FFDAAB"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M353.346 80.9314L351.053 79.6213L366.546 70.7119L368.839 72.0221L353.346 80.9314Z",
    fill: "#9C805F"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M375.187 92.1715L359.693 101.048V84.6379L375.187 75.7285V92.1715Z",
    fill: "#F5CB95"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M359.688 101.05L344.687 92.4029V75.96L359.688 84.64V101.05Z",
    fill: "#D1AD7F"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M353.331 85.9139L351.038 84.6037V79.625L353.331 80.9352V85.9139Z",
    fill: "#705C44"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M350.069 85.5233L345.745 83.0667V78.4482L350.069 80.9049V85.5233Z",
    fill: "#EBEBEB"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M349.453 81.5592L346.179 79.6932V79.2676L349.453 81.1336V81.5592Z",
    fill: "#9E9E9E"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M349.452 82.7033L346.179 80.8045V80.3789L349.452 82.2777V82.7033Z",
    fill: "#9E9E9E"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M349.452 83.8467L346.179 81.948V81.5225L349.452 83.4212V83.8467Z",
    fill: "#9E9E9E"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M349.452 84.8047L347.586 83.7244V83.2988L349.452 84.3791V84.8047Z",
    fill: "#9E9E9E"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M358.281 96.1974L352.189 92.6926V92.1357L358.281 95.6405V96.1974Z",
    fill: "#9C8469"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M358.281 98.1295L352.189 94.6247V94.0352L358.281 97.5726V98.1295Z",
    fill: "#9C8469"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M358.281 99.0822L352.189 95.5774V95.0205L358.281 98.5253V99.0822Z",
    fill: "#9C8469"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M358.281 97.1787L355.237 95.411V94.8545L358.281 96.6223V97.1787Z",
    fill: "#9C8469"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M350.069 88.5666L345.746 86.0779V83.8838L350.069 86.3726V88.5666Z",
    fill: "#EBEBEB"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M347.451 86.2463L347.32 86.2135V85.166L347.451 85.2315V86.2463Z",
    fill: "#424242"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M346.393 85.6556L346.294 85.59V84.5752L346.393 84.6407V85.6556Z",
    fill: "#424242"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M348.858 87.0656L348.76 87.0328V85.9854L348.858 86.0508V87.0656Z",
    fill: "#424242"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M349.117 87.2258L349.019 87.1603V86.1455L349.117 86.2109V87.2258Z",
    fill: "#424242"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M346.109 85.4919L345.945 85.3937V84.3789L346.109 84.4771V85.4919Z",
    fill: "#424242"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M347.221 86.112L347.057 86.0138V84.999L347.221 85.0972V86.112Z",
    fill: "#424242"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M347.747 86.4421L347.714 86.4094V85.3945L347.747 85.4273V86.4421Z",
    fill: "#424242"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M346.737 85.8552L346.704 85.8224V84.8076L346.737 84.8404V85.8552Z",
    fill: "#424242"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M347.908 86.5398L347.875 86.5071V85.4922L347.908 85.525V86.5398Z",
    fill: "#424242"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M348.069 86.6355L348.036 86.6028V85.5879H348.069V86.6355Z",
    fill: "#424242"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M346.603 85.7536H346.537V84.7061L346.603 84.7388V85.7536Z",
    fill: "#424242"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M348.6 86.9371L348.534 86.9045V85.8896H348.6V86.9371Z",
    fill: "#424242"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M349.318 87.3596L349.285 87.3269V86.2793L349.318 86.312V87.3596Z",
    fill: "#424242"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M347.576 86.3435L347.543 86.3107V85.2959L347.576 85.3287V86.3435Z",
    fill: "#424242"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M346.925 85.9538L346.86 85.9211V84.9062L346.925 84.939V85.9538Z",
    fill: "#424242"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M348.37 86.7995L348.206 86.7013V85.6865L348.37 85.7847V86.7995Z",
    fill: "#424242"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M349.675 87.5583L349.511 87.4601V86.4453L349.675 86.5435V87.5583Z",
    fill: "#424242"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M381.406 97.9361L366.405 89.256L381.898 80.3467L396.9 89.0267L381.406 97.9361Z",
    fill: "#FFDAAB"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M375.059 94.2273L372.766 92.8844L388.259 84.0078L390.552 85.318L375.059 94.2273Z",
    fill: "#9C805F"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M396.905 105.469L381.412 114.346V97.9357L396.905 89.0264V105.469Z",
    fill: "#F5CB95"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M381.409 114.35L366.407 105.703V89.2598L381.409 97.9398V114.35Z",
    fill: "#D1AD7F"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M375.057 99.2113L372.764 97.9012V92.8896L375.057 94.2326V99.2113Z",
    fill: "#705C44"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M371.782 98.8207L367.491 96.3314V91.7129L371.782 94.2022V98.8207Z",
    fill: "#EBEBEB"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M371.166 94.8565L367.892 92.9905V92.5322L371.166 94.4309V94.8565Z",
    fill: "#9E9E9E"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M371.166 95.9982L367.892 94.0994V93.6738L371.166 95.5726V95.9982Z",
    fill: "#9E9E9E"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M371.166 97.1099L367.892 95.2439V94.8184L371.166 96.7171V97.1099Z",
    fill: "#9E9E9E"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M371.166 98.0967L369.333 97.0164V96.5908L371.166 97.6711V98.0967Z",
    fill: "#9E9E9E"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M379.996 109.498L373.903 105.993V105.437L379.996 108.941V109.498Z",
    fill: "#9C8469"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M379.996 111.428L373.903 107.924V107.334L379.996 110.871V111.428Z",
    fill: "#9C8469"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M379.996 112.415L373.903 108.877V108.32L379.996 111.825V112.415Z",
    fill: "#9C8469"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M379.996 110.478L376.951 108.71V108.153L379.996 109.921V110.478Z",
    fill: "#9C8469"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M371.782 101.868L367.492 99.3796V97.1855L371.782 99.6744V101.868Z",
    fill: "#EBEBEB"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M369.167 99.5461L369.069 99.5133V98.4658L369.167 98.5313V99.5461Z",
    fill: "#424242"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M368.116 98.9554L368.018 98.8899V97.875L368.116 97.9405V98.9554Z",
    fill: "#424242"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M370.565 100.367L370.467 100.302V99.2871L370.565 99.3525V100.367Z",
    fill: "#424242"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M370.827 100.524L370.728 100.458V99.4434L370.827 99.5088V100.524Z",
    fill: "#424242"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M367.813 98.7938L367.649 98.6955V97.6807L367.813 97.7789V98.7938Z",
    fill: "#424242"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M368.925 99.4148L368.761 99.3166V98.3018L368.925 98.4V99.4148Z",
    fill: "#424242"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M369.453 99.7439L369.421 99.7112V98.6963L369.453 98.7291V99.7439Z",
    fill: "#424242"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M368.476 99.1579L368.41 99.1252V98.1104L368.476 98.1431V99.1579Z",
    fill: "#424242"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M369.653 99.8414L369.588 99.8088V98.7939L369.653 98.8266V99.8414Z",
    fill: "#424242"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M369.788 99.9035H369.755V98.8887H369.788V99.9035Z",
    fill: "#424242"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M368.312 99.0534H368.279V98.0059L368.312 98.0386V99.0534Z",
    fill: "#424242"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M370.306 100.239L370.273 100.206V99.1914H370.306V100.239Z",
    fill: "#424242"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M371.017 100.659L370.984 100.627V99.5791L371.017 99.6119V100.659Z",
    fill: "#424242"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M369.318 99.6472L369.253 99.6145V98.5996L369.318 98.6324V99.6472Z",
    fill: "#424242"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M368.641 99.2556L368.576 99.2228V98.208L368.641 98.2408V99.2556Z",
    fill: "#424242"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M370.113 100.101L369.917 100.003V98.9883L370.113 99.0865V100.101Z",
    fill: "#424242"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M371.418 100.86L371.222 100.762V99.7471L371.418 99.8453V100.86Z",
    fill: "#424242"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M407.526 111.394L392.492 102.746L407.985 93.8369L423.019 102.517L407.526 111.394Z",
    fill: "#FFDAAB"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M401.179 107.691L398.886 106.381L414.379 97.4717L416.672 98.8146L401.179 107.691Z",
    fill: "#9C805F"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M423.022 118.93L407.529 127.839V111.396L423.022 102.52V118.93Z",
    fill: "#F5CB95"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M407.519 127.842L392.484 119.162V102.752L407.519 111.399V127.842Z",
    fill: "#D1AD7F"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M401.169 112.706L398.876 111.363V106.384L401.169 107.694V112.706Z",
    fill: "#705C44"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M397.865 112.314L393.574 109.825V105.206L397.865 107.695V112.314Z",
    fill: "#EBEBEB"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M397.276 108.35L394.003 106.451V106.025L397.276 107.924V108.35Z",
    fill: "#9E9E9E"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M397.276 109.491L394.003 107.592V107.167L397.276 109.066V109.491Z",
    fill: "#9E9E9E"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M397.276 110.603L394.003 108.737V108.312L397.276 110.178V110.603Z",
    fill: "#9E9E9E"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M397.276 111.591L395.41 110.511V110.085L397.276 111.165V111.591Z",
    fill: "#9E9E9E"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M406.08 122.992L400.02 119.487V118.897L406.08 122.435V122.992Z",
    fill: "#9C8469"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M406.08 124.891L400.02 121.386V120.829L406.08 124.334V124.891Z",
    fill: "#9C8469"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M406.08 125.874L400.02 122.369V121.812L406.08 125.317V125.874Z",
    fill: "#9C8469"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M406.08 123.971L403.068 122.203V121.646L406.08 123.382V123.971Z",
    fill: "#9C8469"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M397.865 115.338L393.575 112.882V110.655L397.865 113.144V115.338Z",
    fill: "#EBEBEB"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M395.247 113.049L395.149 112.984V111.969L395.247 112.034V113.049Z",
    fill: "#424242"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M394.218 112.424L394.087 112.391V111.344L394.218 111.409V112.424Z",
    fill: "#424242"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M396.685 113.868L396.587 113.803V112.788L396.685 112.854V113.868Z",
    fill: "#424242"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M396.943 114.029L396.845 113.964V112.916L396.943 112.981V114.029Z",
    fill: "#424242"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M393.937 112.262L393.774 112.164V111.149L393.937 111.248V112.262Z",
    fill: "#424242"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M395.005 112.916L394.842 112.818V111.803L395.005 111.868V112.916Z",
    fill: "#424242"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M395.57 113.213H395.537V112.165L395.57 112.198V113.213Z",
    fill: "#424242"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M394.563 112.657L394.53 112.624V111.609H394.563V112.657Z",
    fill: "#424242"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M395.734 113.343L395.701 113.31V112.263L395.734 112.295V113.343Z",
    fill: "#424242"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M395.895 113.406L395.862 113.373V112.358L395.895 112.391V113.406Z",
    fill: "#424242"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M394.429 112.558L394.363 112.526V111.511L394.429 111.544V112.558Z",
    fill: "#424242"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M396.426 113.71L396.36 113.677V112.662L396.426 112.695V113.71Z",
    fill: "#424242"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M397.144 114.129L397.078 114.096V113.081L397.144 113.114V114.129Z",
    fill: "#424242"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M395.401 113.145L395.369 113.112V112.064L395.401 112.097V113.145Z",
    fill: "#424242"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M394.727 112.757L394.694 112.724V111.677L394.727 111.709V112.757Z",
    fill: "#424242"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M396.194 113.603L396.03 113.472V112.457L396.194 112.555V113.603Z",
    fill: "#424242"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M397.501 114.329L397.337 114.263V113.216L397.501 113.314V114.329Z",
    fill: "#424242"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M232.014 170.361C232.014 168.429 233.586 166.856 235.519 166.856C237.451 166.856 239.023 168.429 239.023 170.361V172.425H238.336C237.713 173.276 236.665 173.833 235.519 173.833C234.372 173.833 233.357 173.276 232.702 172.425H232.014V170.361Z",
    fill: "#414042"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M232.014 172.428C232.014 174.36 233.586 175.932 235.519 175.932C237.451 175.932 239.023 174.36 239.023 172.428C239.023 170.495 237.451 168.923 235.519 168.923C233.586 168.923 232.014 170.495 232.014 172.428Z",
    fill: "#58595B"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M233.492 172.393C233.492 173.506 234.409 174.423 235.522 174.423C236.635 174.423 237.552 173.506 237.552 172.393C237.552 171.279 236.635 170.362 235.522 170.362C234.409 170.362 233.492 171.279 233.492 172.393Z",
    fill: "#231F20"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M293.171 170.361C293.171 168.429 294.744 166.856 296.643 166.856C298.543 166.856 300.148 168.429 300.148 170.361V172.425H299.46C298.838 173.276 297.822 173.833 296.643 173.833C295.464 173.833 294.481 173.276 293.826 172.425H293.138V170.361H293.171Z",
    fill: "#414042"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M293.171 172.428C293.171 174.36 294.744 175.932 296.643 175.932C298.543 175.932 300.148 174.36 300.148 172.428C300.148 170.495 298.576 168.923 296.643 168.923C294.711 168.923 293.171 170.495 293.171 172.428Z",
    fill: "#58595B"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M294.643 172.393C294.643 173.506 295.56 174.423 296.673 174.423C297.787 174.423 298.704 173.506 298.704 172.393C298.704 171.279 297.787 170.362 296.673 170.362C295.56 170.362 294.643 171.279 294.643 172.393Z",
    fill: "#231F20"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M263.717 185.462H267.779V193.847H263.717V185.462Z",
    fill: "#414042"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M261.947 164.73V149.597C261.947 148.385 263.65 147.37 265.746 147.37C267.843 147.37 269.546 148.353 269.546 149.597V164.73H300.172V167.252C300.172 168.464 298.436 169.447 296.34 169.447H269.546V184.907C269.546 186.119 267.843 187.135 265.746 187.135C263.65 187.135 261.947 186.152 261.947 184.907V169.447H235.153C233.057 169.447 231.321 168.464 231.321 167.252V164.73H261.947Z",
    fill: "black"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M261.947 182.387V166.926H235.153C233.057 166.926 231.321 165.944 231.321 164.732C231.321 163.52 233.057 162.537 235.153 162.537H261.947V147.077C261.947 145.865 263.65 144.85 265.746 144.85C267.843 144.85 269.546 145.832 269.546 147.077V162.537H296.34C298.436 162.537 300.172 163.52 300.172 164.732C300.172 165.944 298.436 166.926 296.34 166.926H269.546V182.387C269.546 183.599 267.843 184.614 265.746 184.614C263.65 184.614 261.947 183.631 261.947 182.387Z",
    fill: "#414042"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M268.44 143.309C267.719 142.884 266.736 142.687 265.754 142.654L264.738 142.72C264.116 142.818 263.526 143.015 263.035 143.277C261.528 144.128 261.528 145.537 263.035 146.388C264.542 147.24 266.933 147.24 268.44 146.388C269.946 145.537 269.946 144.128 268.44 143.277V143.309Z",
    fill: "#414042"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M263.034 146.423C264.541 147.274 266.932 147.274 268.439 146.423C269.127 146.03 269.52 145.506 269.552 144.949V164.995C269.552 165.552 269.192 166.109 268.439 166.534C266.965 167.386 264.541 167.386 263.034 166.534C262.248 166.076 261.888 165.486 261.921 164.897V144.851C261.921 145.407 262.314 145.964 263.034 146.39V146.423Z",
    fill: "black"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M268.702 135.186C267.916 134.727 266.835 134.498 265.787 134.498L264.674 134.564C263.986 134.662 263.331 134.858 262.807 135.186C261.169 136.136 261.169 137.643 262.807 138.592C264.444 139.542 267.065 139.542 268.67 138.592C270.307 137.643 270.307 136.136 268.67 135.186H268.702Z",
    fill: "#414042"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M262.806 138.593C264.443 139.543 267.064 139.543 268.669 138.593C269.422 138.167 269.848 137.577 269.881 137.021V145.439C269.881 146.061 269.455 146.651 268.669 147.142C267.064 148.092 264.411 148.092 262.806 147.142C261.954 146.651 261.561 145.995 261.594 145.34V136.955C261.594 137.577 261.987 138.167 262.806 138.626V138.593Z",
    fill: "#231F20"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M272.688 82.086C272.688 82.086 277.47 78.0571 278.846 77.4347C280.221 76.8124 288.312 77.402 288.312 79.1053C288.312 80.4482 284.61 81.2671 284.61 81.2671C284.61 81.2671 281.925 82.3808 281.925 84.3133C281.892 84.5753 285.004 84.6736 285.036 85.427C285.069 86.1803 283.235 86.6061 281.171 86.9337C279.108 87.2284 275.308 86.5406 275.308 86.5406L272.688 82.1187V82.086Z",
    fill: "#0D0D0D"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M258.835 85.0744C269.12 83.5021 272.1 82.2247 272.723 82.0937C273.345 81.9626 276.097 83.3056 275.343 86.5156C269.415 88.1533 264.993 91.8546 264.993 91.8546L258.18 88.4808C258.18 88.4808 258.573 85.5985 258.835 85.0744Z",
    fill: "#F0C6B4"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M246.617 81.2045C246.617 81.2045 247.632 79.5995 247.96 75.7999C247.796 70.8211 254.707 75.1121 254.707 75.1121L258.9 76.8153L260.276 79.5012C260.276 79.5012 260.538 80.2546 259.948 80.7459C258.835 84.742 259.817 87.4935 259.817 87.4935L251.301 87.9193L246.617 84.8731V81.2372V81.2045Z",
    fill: "#F0C6B4"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M247.667 94.9919C244.457 98.2019 239.97 98.0708 236.137 95.0246C232.108 91.8473 233.189 84.281 235.155 82.4795C237.873 80.0228 244.13 79.9574 247.569 83.4294C251.008 86.8687 250.844 91.7819 247.634 94.9591L247.667 94.9919Z",
    fill: "#CF7C00"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M279.139 151.623C279.139 151.623 285.198 156.537 284.249 158.666C283.823 159.616 280.744 159.223 277.992 158.273C275.044 157.257 273.112 158.011 271.048 156.962C270.066 156.438 269.378 154.342 269.542 154.015C270.753 151.689 270.164 152.213 271.998 150.412C272.227 149.855 279.139 151.656 279.139 151.656V151.623Z",
    fill: "#3C2415"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M273.246 138.92C272.853 142.13 269.774 148.189 271.019 151.792C273.672 155.592 280.878 153.888 282.286 150.908C282.909 140.164 286.381 133.318 286.381 133.318C286.381 133.318 273.639 135.71 273.246 138.92Z",
    fill: "#1C4B94"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M301.519 158.536C305.777 161.255 308.004 161.877 309.085 162.434C310.33 163.056 311.607 165.709 308.954 166.037C306.268 166.397 289.4 166.987 287.434 164.694C285.6 162.565 287.893 157.16 287.893 157.16C287.893 157.16 300.635 157.488 301.519 158.536Z",
    fill: "#3C2415"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M305.649 120.277C306.828 125.78 301.292 145.859 301.554 158.535C301.194 160.533 289.73 163.416 287.404 157.651C286.716 155.98 289.468 141.503 291.531 133.052L305.682 120.277H305.649Z",
    fill: "#2565C4"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M254.315 124.806C263.552 119.467 271.184 116.781 272.297 118.353L300.205 134.076L262.831 157.921C262.831 157.921 234.17 141.609 234.17 140.954C234.17 138.498 244.324 130.604 254.315 124.839V124.806Z",
    fill: "black"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M262.536 157.465C262.896 159.888 274.721 156.711 284.744 150.946C294.767 145.181 300.532 137.222 300.532 134.733C300.532 132.243 294.309 135.912 284.285 141.677C274.295 147.442 262.045 154.189 262.536 157.465Z",
    fill: "#414042"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M268.013 115.596C268.013 115.596 271.747 110.683 277.413 111.894C283.113 113.106 285.766 116.84 286.388 120.509C286.978 124.145 286.618 126.274 283.244 128.632C279.837 130.991 268.045 129.32 268.045 129.32V115.596H268.013Z",
    fill: "#1C4B94"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M246.623 81.2045C254.32 86.8383 259.921 86.7401 259.921 86.7401C259.921 86.7401 266.669 91.1293 269.879 95.2892C275.513 102.561 271.942 118.48 271.942 118.48C271.942 118.48 272.761 122.05 271.68 123.065C270.567 124.081 269.813 127.16 269.813 127.16L254.746 126.898C254.746 126.898 244.297 120.248 244.1 119.659C244.297 112.813 239.809 104.69 239.809 104.69L238.237 102.266C238.237 102.266 237.058 100.464 236.01 92.6032C234.831 86.7728 238.827 79.0426 246.623 81.2045Z",
    fill: "#FF9800"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M269.353 123.881C263.719 124.995 258.838 111.533 258.838 111.533L237.482 100.92C237.482 100.92 241.085 118.149 241.97 128.729C243.018 129.679 253.991 130.694 253.991 130.694L264.734 131.972L271.416 126.567C271.416 126.567 273.382 123.193 271.94 118.477C271.94 118.477 272.792 121.949 269.353 123.881Z",
    fill: "#2565C4"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M257.206 111.924C257.206 111.924 254.683 98.5932 259.269 93.1558C262.184 89.4218 267.982 93.2213 267.982 93.2213C268.244 91.518 264.772 89.1269 263.658 88.8976C262.545 88.6683 258.68 87.1289 255.011 91.9766C250.818 97.5122 253.111 109.697 253.111 109.697L257.206 111.957V111.924Z",
    fill: "#2565C4"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M243.184 105.145C243.184 105.145 234.733 85.3278 246.59 81.2007C246.59 81.2007 244.756 80.2836 242.627 81.168C232.538 85.1641 239.057 102.917 239.057 102.917L243.151 105.177L243.184 105.145Z",
    fill: "#2565C4"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M291.491 133.088C290.443 133.809 271.544 146.125 266.598 146.944C261.684 147.763 248.746 144.061 245.7 139.901C238.854 129.453 243.472 121.329 243.472 121.329C243.472 121.329 255.035 127.815 262.045 127.815C269.054 127.815 270.495 125.588 270.495 125.588V123.295C270.495 123.295 293.719 116.744 299.909 116.776C301.875 116.776 304.79 117.137 305.609 120.281L291.459 133.056L291.491 133.088Z",
    fill: "#2565C4"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M303.452 102.688C303.649 102.033 307.219 97.4468 308.693 96.1366C312.198 93.0577 315.08 95.9074 315.375 96.1366C317.341 98.6915 317.373 102.36 316.784 102.688C315.441 103.441 314.098 102.72 313.672 102.557C313.05 104.162 310.429 106.16 309.479 106.651C308.529 107.11 307.383 107.241 307.383 107.241C307.383 107.241 303.256 103.343 303.452 102.72V102.688Z",
    fill: "#0D0D0D"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M292.179 107.961C297.584 106.258 302.727 103.245 303.447 102.688C304.626 101.836 308.459 106.422 307.247 107.47C302.89 110.844 295.913 117.559 295.913 117.559L292.212 112.252C292.212 112.252 291.262 107.863 292.212 107.961H292.179Z",
    fill: "#F0C6B4"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M286.679 110.776C286.417 109.466 289.431 106.879 292.051 107.566C294.671 108.254 297.751 114.838 295.621 118.277C293.82 121.291 289.594 120.013 289.594 120.013C289.594 120.013 286.941 112.087 286.679 110.776Z",
    fill: "#F5B400"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M265.811 63.8131C268.235 68.6281 264.763 79.5683 263.78 80.4527C262.797 81.3371 259.915 80.7475 259.915 80.7475C259.915 80.7475 257.098 78.4873 256.574 75.998C256.05 73.5086 257.917 67.9075 257.917 67.9075L262.503 62.5029C262.503 62.5029 265.582 63.0925 265.811 63.8131Z",
    fill: "#F0C6B4"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M247.855 76.9114C249.984 79.8921 255.258 79.9249 256.338 79.6301C258.631 79.0405 258.5 73.4722 260.99 71.9654C261.743 71.4086 262.3 72.6533 263.184 71.9654C263.643 71.6051 264.396 69.5415 264.626 67.609C265.019 64.268 265.706 64.53 265.87 63.5474C266.296 60.8615 259.581 53.8519 250.672 59.8133C247.233 61.4838 243.105 70.1967 247.855 76.8787V76.9114Z",
    fill: "#603913"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M260.544 96.1379C265.916 89.8162 273.678 100.691 274.759 100.986C275.84 101.28 285.405 110.845 286.912 110.845C290.842 109.142 292.644 118.018 291.268 119.296C290.056 120.409 284.619 122.407 282.26 121.523C277.904 118.935 264.573 109.731 264.573 109.731C264.573 109.731 255.139 102.46 260.511 96.1379H260.544Z",
    fill: "#CF7C00"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M286.936 110.841C286.936 110.841 285.756 117.752 286.87 117.981C287.984 118.211 286.936 110.841 286.936 110.841Z",
    fill: "#FF9800"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M229.882 83.9169C230.176 83.8514 230.373 83.7858 230.602 83.8513L230.733 83.9169C230.832 83.9497 230.93 83.9824 231.061 84.0806L260.049 100.753L262.178 157.779L233.386 141.402C229.849 139.109 222.872 85.2599 229.882 83.9169Z",
    fill: "url(#paint19_linear_1504_151244)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M257.985 131.25C260.048 148.151 260.016 159.321 263.16 157.748C266.305 156.176 266.01 144.253 265.093 127.253C264.176 109.992 262.374 99.2152 259.197 100.787C256.052 102.36 255.758 113.071 257.952 131.217L257.985 131.25Z",
    fill: "#414042"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M216.197 205.328L51.9477 297.374L0 268.2L164.288 176.154L216.197 205.328Z",
    fill: "black"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8571 59.0066C96.2832 64.0574 94.7336 66.319 94.7336 66.319L96.2831 69.862L101.28 73.179L105.89 73.9706L108.641 70.0128L104.961 62.3612L101.009 59.685C101.009 59.685 95.7409 57.9135 95.8959 59.0443L95.8571 59.0066Z",
    fill: "#C7A495"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M113.829 62.1777C113.829 62.1777 123.94 63.4216 125.141 73.8625C126.341 84.341 128.859 93.9903 128.859 93.9903L132.617 97.835L127.968 106.806C127.968 106.806 121.615 104.054 119.446 100.134C117.935 97.4581 112.241 64.3639 112.241 64.3639L113.829 62.1777Z",
    fill: "#CF7C00"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M131.037 107.897C131.037 107.897 125.071 109.97 123.676 104.844C122.398 100.094 125.613 95.5713 129.255 94.9683C133.981 94.1767 136.073 98.8506 135.569 100.848C135.414 101.451 131.037 107.897 131.037 107.897Z",
    fill: "#DC6803"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M139.762 104.612C135.617 101.521 132.364 98.2038 132.364 98.2038C132.364 98.2038 129.768 96.8469 127.521 100.654C125.12 104.687 128.025 106.082 128.025 106.082C128.025 106.082 133.177 108.117 136.47 109.738C137.128 107.627 138.755 106.27 139.801 104.574L139.762 104.612Z",
    fill: "#F0C6B4"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M105.82 72.0811C102.604 74.6442 94.3145 66.1256 94.7019 66.3518C93.501 67.7841 92.1838 68.9526 92.1838 68.9526L87.4191 73.0987C87.4191 73.0987 86.5668 74.0034 84.7074 75.0588C84.1651 75.3226 90.8281 116.596 90.8281 116.596L104.27 118.82L119.339 109.849L121.625 108.379C121.625 108.379 125.576 94.9605 125.072 84.5197C124.336 68.9903 112.521 64.3164 112.521 64.3164L106.788 65.4849C106.788 65.4849 109.035 69.518 105.781 72.0811H105.82Z",
    fill: "#FF9800"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M100.212 123.683C105.287 110.641 99.3602 91.6061 99.3602 91.6061C99.3602 91.6061 115.359 85.3868 122.681 77.8105C126.981 90.8522 122.293 112.676 122.293 112.676L118.109 119.913L108.309 124.926C108.309 124.926 98.8179 127.942 100.212 123.645V123.683Z",
    fill: "#2565C4"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2367 68.9547C104.633 73.8548 106.376 90.4395 106.376 90.4395L101.301 92.3618C101.301 92.3618 99.7131 76.4179 87.4719 73.0632C87.4719 72.0455 91.0359 69.2185 92.2367 68.917V68.9547Z",
    fill: "#2565C4"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M108.765 60.815C120.038 65.6397 121.665 80.6413 121.665 80.6413L117.249 83.2799C117.249 83.2799 115.079 67.3358 102.838 63.9812C102.838 62.9635 107.564 61.0789 108.765 60.7773V60.815Z",
    fill: "#2565C4"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M118.225 199.149C121.208 203.22 130.621 205.481 130.815 207.781C130.815 208.421 131.318 210.608 129.614 211.361C124.462 212.568 114.932 207.63 114.932 207.63C114.932 207.63 105.984 207.441 105.209 205.708C104.395 203.974 105.209 198.357 105.209 198.357C105.209 198.357 117.45 198.056 118.264 199.149H118.225Z",
    fill: "#3C2415"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M122.954 127.419C124.233 145.474 119.197 161.079 118.422 165.074C116.718 179.247 118.965 196.209 118.81 199.94C118.693 203.672 105.445 206.687 103.585 200.129C102.617 193.947 102.656 175.478 105.019 166.582C105.948 163.114 101.958 135.033 101.958 135.033C101.958 135.033 122.528 123.839 122.916 127.419H122.954Z",
    fill: "#1C4B94"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2325 211.178C92.0388 213.176 98.3143 221.958 96.8035 224.333C95.409 226.482 88.7848 225.652 86.0732 223.579C83.3615 221.506 81.2697 214.872 80.6499 212.498C80.0301 210.123 80.6499 206.655 80.6499 206.655L91.1478 208.163C91.1478 208.163 92.465 209.218 92.2713 211.178H92.2325Z",
    fill: "#3C2415"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M122.285 112.677C122.285 112.677 106.945 123.872 101.25 123.608C94.1227 123.268 89.9391 117.728 89.9391 117.728C89.9391 117.728 86.4139 123.645 85.3292 127.339C84.2833 130.995 84.7481 165.107 82.8887 169.932C81.0293 174.719 80.0996 175.737 79.2087 179.393C78.3177 183.049 78.6663 201.481 79.2087 207.361C79.7897 213.241 89.0868 215.615 92.5732 211.469C92.1858 196.204 92.6507 180.976 95.4786 175.85C99.3911 168.688 105.396 141.851 105.783 140.833C113.802 136.8 122.944 128.96 122.944 127.49C122.944 126.02 122.285 112.752 122.285 112.752V112.677Z",
    fill: "#2565C4"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M112.945 45.4351C119.181 50.6366 116.78 57.836 116.78 57.836C116.78 57.836 115.23 69.4453 114.184 70.5384C113.138 71.6315 111.124 72.2722 110.427 72.3099C108.335 72.4984 100.974 67.3345 99.9285 66.0906C98.8826 64.8468 99.3475 62.4345 99.3475 62.4345C99.3475 62.4345 95.9385 61.0398 95.5899 57.9113C95.2412 54.7828 95.5899 53.0113 95.5899 53.0113L98.2628 47.3197L103.957 43.8896H108.606C108.606 43.8896 112.17 44.8697 112.945 45.4351Z",
    fill: "#F0C6B4"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5971 57.913C95.5971 57.913 96.3719 54.4453 98.3088 56.4054C99.2385 57.3477 98.8511 57.913 99.5484 59.0438C100.246 60.1369 101.95 60.8154 102.415 60.3631C102.88 59.9108 103.306 55.0107 102.802 53.3899C102.299 51.7691 99.4321 50.5253 101.408 48.3768C103.383 46.2283 110.937 52.4476 113.455 50.0353C115.199 48.1883 110.782 35.3352 98.1538 42.8737C90.871 47.2461 95.5584 57.8754 95.5584 57.8754L95.5971 57.913Z",
    fill: "#603913"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M136.162 105.598C137.169 104.543 141.973 103.601 145.149 106.804C146.854 108.501 146.583 110.951 145.885 112.684C145.188 114.381 143.755 117.283 141.702 116.906C139.958 116.567 141.004 113.589 141.004 113.589C141.004 113.589 138.332 112.421 137.595 110.611C137.595 110.611 136.782 110.988 136.007 110.084C135.194 109.179 135.155 106.691 136.162 105.636V105.598Z",
    fill: "#0D0D0D"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4664 194.649L159.358 117.749L165.023 127.947L164.969 185.958L20.748 269.397L20.8017 211.385L26.4664 194.649Z",
    fill: "#D0D5DD"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M23.434 192.903L26.4676 194.652L20.803 211.388L17.7693 209.639L23.434 192.903Z",
    fill: "url(#paint20_linear_1504_151244)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M23.434 192.903L26.4676 194.652L20.803 211.388L17.7693 209.639L23.434 192.903Z",
    fill: "url(#paint21_linear_1504_151244)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4285 192.9L156.32 116L159.354 117.749L26.4621 194.649L23.4285 192.9Z",
    fill: "url(#paint22_linear_1504_151244)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7692 209.644L54.4687 230.873L54.4419 288.885L17.7692 267.655V209.644Z",
    fill: "url(#paint23_linear_1504_151244)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0604 193.568V195.29L63.2557 186.465V176.939L62.1013 177.612V185.442L48.0604 193.568Z",
    fill: "#344054"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0604 185.757V193.56L62.1013 185.434V177.604L48.0604 185.757Z",
    fill: "url(#paint24_linear_1504_151244)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7949 207.562L44.6212 197.257V187.731L43.4668 188.404V196.207L27.654 205.355L26.7949 207.562Z",
    fill: "#344054"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6515 205.351L43.4643 196.202V188.399L31.4637 195.341L27.6515 205.351Z",
    fill: "url(#paint25_linear_1504_151244)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M141.317 139.564V141.286L159.116 130.981L154.471 124.146L154.149 124.362L157.962 129.931L141.317 139.564Z",
    fill: "#344054"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M141.317 131.763V139.566L157.962 129.933L154.149 124.363L141.317 131.763Z",
    fill: "url(#paint26_linear_1504_151244)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6859 182.779V184.501L81.8812 175.703V166.178L80.7268 166.85V174.653L66.6859 182.779Z",
    fill: "#344054"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6859 174.972V182.775L80.7268 174.649V166.846L66.6859 174.972Z",
    fill: "url(#paint27_linear_1504_151244)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3239 171.984V173.706L100.519 164.908V155.383L99.3647 156.055V163.859L85.3239 171.984Z",
    fill: "#344054"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M85.324 164.181V171.984L99.3649 163.858V156.055L85.324 164.181Z",
    fill: "url(#paint28_linear_1504_151244)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M103.959 161.199V162.921L119.155 154.123V144.598L118 145.27V153.073L103.959 161.199Z",
    fill: "#344054"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M103.959 153.392V161.196L118 153.07V145.267L103.959 153.392Z",
    fill: "url(#paint29_linear_1504_151244)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M122.58 150.437V152.159L137.775 143.361V133.809L136.621 134.481V142.311L122.58 150.437Z",
    fill: "#344054"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M122.58 142.629V150.432L136.621 142.306V134.477L122.58 142.629Z",
    fill: "url(#paint30_linear_1504_151244)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M174.369 119.82C174.369 119.82 174.262 119.766 174.208 119.739C173.457 119.363 172.436 119.443 171.336 120.089L119.79 149.902L16.2149 209.851C16.0807 209.931 15.9196 210.012 15.7854 210.12C13.6645 211.6 12 214.667 12 217.169V217.573C12 218.918 12.4564 219.86 13.235 220.291L38.632 234.982L199.579 134.377L174.396 119.82H174.369Z",
    fill: "url(#paint31_linear_1504_151244)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M199.959 137.609V137.986C199.959 140.138 198.428 142.775 196.576 143.852L41.4551 233.613C40.3543 234.259 39.3879 234.205 38.7704 233.613C39.2536 233.613 39.7906 233.479 40.3812 233.156L195.502 143.394C197.354 142.318 198.885 139.681 198.885 137.528V137.152C198.885 136.264 198.616 135.591 198.187 135.188C199.234 135.241 199.959 136.129 199.959 137.609Z",
    fill: "#212121"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M198.854 137.175V137.552C198.854 139.704 197.323 142.341 195.471 143.418L40.3502 233.179C39.7596 233.502 39.2226 233.663 38.7394 233.637C38.3098 233.233 38.0414 232.56 38.0414 231.672V231.269C38.0414 229.116 39.5716 226.479 41.4241 225.403L196.545 135.641C197.135 135.292 197.672 135.157 198.156 135.184C198.585 135.588 198.854 136.26 198.854 137.148V137.175Z",
    fill: "#878787"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M196.572 135.668C198.424 134.592 199.954 135.479 199.954 137.632V138.009C199.954 140.161 198.424 142.798 196.572 143.874L41.4507 233.636C39.5982 234.712 38.068 233.851 38.068 231.672V231.268C38.068 229.116 39.5982 226.479 41.4507 225.402L196.572 135.641V135.668ZM196.572 134.699L41.4507 224.461C39.115 225.806 37.2089 229.089 37.2089 231.806V232.21C37.2089 234.901 39.115 236.004 41.4507 234.658L196.572 144.897C198.907 143.552 200.786 140.269 200.786 137.551V137.175C200.786 134.484 198.88 133.381 196.572 134.726V134.699Z",
    fill: "#363636"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M117.13 151.41L118.822 150.441L144.058 165.052L142.393 166.021L117.13 151.41Z",
    fill: "#363636"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M110.393 155.309L112.058 154.341L137.321 168.951L135.629 169.92L110.393 155.309Z",
    fill: "#363636"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M103.635 159.213L105.299 158.244L130.562 172.882L128.871 173.85L103.635 159.213Z",
    fill: "#363636"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8613 163.139L98.5258 162.17L123.789 176.78L122.124 177.749L96.8613 163.139Z",
    fill: "#363636"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M90.093 167.046L91.7575 166.077L117.02 180.688L115.356 181.683L90.093 167.046Z",
    fill: "#363636"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3317 170.972L84.9962 170.003L110.259 184.613L108.595 185.582L83.3317 170.972Z",
    fill: "#363636"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M76.573 174.877L78.2375 173.908L103.5 188.519L101.836 189.487L76.573 174.877Z",
    fill: "#363636"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8042 178.8L71.4956 177.805L96.7584 192.442L95.067 193.411L69.8042 178.8Z",
    fill: "#363636"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0312 182.697L64.7226 181.729L89.9854 196.339L88.2941 197.308L63.0312 182.697Z",
    fill: "#363636"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M164.459 124.026L166.15 123.058L191.386 137.668L189.722 138.637L164.459 124.026Z",
    fill: "#363636"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M157.697 127.918L159.389 126.949L184.652 141.56L182.96 142.528L157.697 127.918Z",
    fill: "#363636"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M150.958 131.85L152.622 130.881L177.885 145.491L176.221 146.46L150.958 131.85Z",
    fill: "#363636"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M144.192 135.746L145.857 134.777L171.12 149.388L169.455 150.356L144.192 135.746Z",
    fill: "#363636"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M137.431 139.675L139.095 138.68L164.358 153.317L162.694 154.286L137.431 139.675Z",
    fill: "#363636"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M130.665 143.579L132.329 142.61L157.592 157.221L155.928 158.189L130.665 143.579Z",
    fill: "#363636"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M123.906 147.478L125.571 146.51L150.833 161.147L149.169 162.089L123.906 147.478Z",
    fill: "#363636"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2991 186.6L57.9636 185.631L83.2264 200.268L81.5351 201.237L56.2991 186.6Z",
    fill: "#363636"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5234 190.528L51.1879 189.56L76.4508 204.17L74.7863 205.139L49.5234 190.528Z",
    fill: "#363636"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7694 194.433L44.4339 193.465L69.6967 208.075L68.0323 209.044L42.7694 194.433Z",
    fill: "#363636"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9985 198.358L37.663 197.39L62.9259 212L61.2614 212.969L35.9985 198.358Z",
    fill: "#363636"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2397 202.261L30.9043 201.292L56.1671 215.902L54.5026 216.871L29.2397 202.261Z",
    fill: "#363636"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4714 206.166L24.1628 205.197L49.3988 219.835L47.7343 220.803L22.4714 206.166Z",
    fill: "#363636"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M15.739 210.095L17.4035 209.126L42.6663 223.736L40.975 224.705L15.739 210.095Z",
    fill: "#363636"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9899 222.686L49.9966 222.174C49.5939 221.986 49.0569 222.04 48.4663 222.39C47.1776 223.143 46.1306 224.946 46.1306 226.426C46.1306 227.206 46.4259 227.744 46.8823 227.959L47.5535 228.282L47.7146 228.04C47.9562 227.986 48.1978 227.905 48.4394 227.744C49.7281 226.991 50.7751 225.188 50.7751 223.708C50.7751 223.493 50.7483 223.277 50.6946 223.116L50.963 222.659L50.9899 222.686Z",
    fill: "#A6A6A6"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5504 224.114C51.5504 225.594 50.5034 227.424 49.2147 228.15C47.9261 228.904 46.879 228.285 46.879 226.805C46.879 225.325 47.9261 223.522 49.2147 222.769C50.5034 222.016 51.5504 222.634 51.5504 224.114Z",
    fill: "#5C5C5C"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3975 224.784C50.3975 225.537 49.8877 226.424 49.2437 226.801C48.7876 227.043 48.4119 226.989 48.2241 226.693C48.3583 226.693 48.5461 226.639 48.7071 226.532C49.351 226.155 49.8608 225.268 49.8608 224.515C49.8608 224.273 49.8072 224.085 49.7267 223.95C50.1292 223.95 50.3975 224.246 50.3975 224.784Z",
    fill: "#A6A6A6"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8697 224.515C49.8697 225.241 49.3599 226.155 48.716 226.532C48.555 226.639 48.3672 226.693 48.233 226.693C48.1525 226.559 48.0989 226.37 48.0989 226.128C48.0989 225.375 48.6087 224.488 49.2526 224.112C49.4136 224.004 49.5746 223.977 49.7356 223.95C49.8161 224.085 49.8697 224.273 49.8697 224.515Z",
    fill: "#4A4A4A"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5054 214.855L63.5121 214.344C63.1094 214.156 62.5724 214.21 61.9818 214.559C60.6932 215.313 59.6461 217.116 59.6461 218.595C59.6461 219.376 59.9414 219.914 60.3978 220.129L61.069 220.452L61.2301 220.21C61.4717 220.156 61.7133 220.075 61.9549 219.914C63.2436 219.161 64.2906 217.358 64.2906 215.878C64.2906 215.663 64.2906 215.447 64.2101 215.286L64.4785 214.829L64.5054 214.855Z",
    fill: "#A6A6A6"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0655 216.282C65.0655 217.762 64.0185 219.565 62.7298 220.318C61.4412 221.072 60.3942 220.453 60.3942 218.973C60.3942 217.493 61.4412 215.69 62.7298 214.937C64.0185 214.184 65.0655 214.802 65.0655 216.282Z",
    fill: "#5C5C5C"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8884 216.955C63.8884 217.708 63.3786 218.595 62.7347 218.972C62.3054 219.214 61.9029 219.16 61.7151 218.864C61.8492 218.864 62.0371 218.81 62.1981 218.703C62.842 218.326 63.3518 217.439 63.3518 216.686C63.3518 216.444 63.2981 216.256 63.2176 216.121C63.6201 216.121 63.8884 216.417 63.8884 216.955Z",
    fill: "#A6A6A6"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3464 216.686C63.3464 217.439 62.8367 218.326 62.1927 218.703C62.0049 218.81 61.8439 218.864 61.7097 218.864C61.6292 218.73 61.5756 218.541 61.5756 218.299C61.5756 217.546 62.1122 216.659 62.7293 216.282C62.8903 216.175 63.0781 216.121 63.2123 216.121C63.2928 216.256 63.3464 216.444 63.3464 216.686Z",
    fill: "#4A4A4A"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3532 208.023L75.3598 207.512C74.9571 207.324 74.4202 207.378 73.8296 207.727C72.5409 208.454 71.4939 210.284 71.4939 211.763C71.4939 212.544 71.7892 213.082 72.2456 213.297L72.9168 213.62L73.0778 213.378C73.3195 213.324 73.5611 213.243 73.8027 213.082C75.0914 212.329 76.1384 210.526 76.1384 209.046C76.1384 208.831 76.1115 208.615 76.0578 208.454L76.3263 207.996L76.3532 208.023Z",
    fill: "#A6A6A6"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9138 209.45C76.9138 210.93 75.8667 212.733 74.5781 213.486C73.2894 214.24 72.2424 213.621 72.2424 212.141C72.2424 210.661 73.2894 208.858 74.5781 208.105C75.8667 207.352 76.9138 207.97 76.9138 209.45Z",
    fill: "#5C5C5C"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7362 210.121C75.7362 210.874 75.2264 211.761 74.5825 212.138C74.1532 212.38 73.7507 212.326 73.5629 212.03C73.7239 212.03 73.8848 211.976 74.0458 211.869C74.6898 211.492 75.1996 210.605 75.1996 209.852C75.1996 209.61 75.1459 209.422 75.0654 209.287C75.4679 209.287 75.7362 209.583 75.7362 210.121Z",
    fill: "#A6A6A6"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1947 209.851C75.1947 210.604 74.6849 211.491 74.041 211.868C73.88 211.975 73.6922 212.029 73.558 212.029C73.4775 211.895 73.4238 211.706 73.4238 211.464C73.4238 210.711 73.9336 209.824 74.5776 209.447C74.7386 209.34 74.9264 209.286 75.0606 209.286C75.1679 209.421 75.1947 209.609 75.1947 209.851Z",
    fill: "#4A4A4A"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1741 201.187L87.1808 200.675C86.7781 200.487 86.2411 200.568 85.6505 200.891C84.3619 201.644 83.3148 203.447 83.3148 204.927C83.3148 205.707 83.6102 206.245 84.0665 206.487L84.7377 206.81L84.8988 206.568C85.1404 206.514 85.382 206.433 85.6236 206.299C86.9123 205.545 87.9593 203.743 87.9593 202.263C87.9593 202.048 87.9593 201.859 87.8788 201.671L88.1473 201.213L88.1741 201.187Z",
    fill: "#A6A6A6"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7369 202.607C88.7369 204.087 87.6899 205.89 86.4012 206.644C85.1126 207.397 84.0656 206.778 84.0656 205.298C84.0656 203.818 85.1126 202.016 86.4012 201.262C87.6899 200.509 88.7369 201.128 88.7369 202.607Z",
    fill: "#5C5C5C"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5743 203.289C87.5743 204.015 87.0645 204.929 86.4206 205.306C85.9913 205.575 85.5888 205.494 85.401 205.198C85.5352 205.198 85.723 205.144 85.884 205.037C86.5279 204.66 87.0377 203.773 87.0377 203.02C87.0377 202.805 86.9841 202.59 86.9036 202.455C87.306 202.455 87.5743 202.751 87.5743 203.289Z",
    fill: "#A6A6A6"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0519 203.02C87.0519 203.773 86.5421 204.66 85.8981 205.037C85.7372 205.144 85.5493 205.198 85.4152 205.198C85.3347 205.064 85.281 204.875 85.281 204.633C85.281 203.88 85.7908 202.993 86.4348 202.616C86.5958 202.509 86.7836 202.455 86.9177 202.455C86.9982 202.59 87.0519 202.778 87.0519 203.02Z",
    fill: "#4A4A4A"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M100.01 194.33L99.0167 193.819C98.614 193.63 98.0771 193.684 97.4864 194.034C96.1978 194.787 95.1508 196.59 95.1508 198.07C95.1508 198.85 95.4461 199.389 95.9025 199.604L96.5736 199.927L96.7347 199.685C96.9763 199.631 97.218 199.55 97.4596 199.389C98.7482 198.635 99.7953 196.832 99.7953 195.353C99.7953 195.137 99.7953 194.922 99.7416 194.761L100.01 194.303V194.33Z",
    fill: "#A6A6A6"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M100.573 195.757C100.573 197.237 99.5258 199.04 98.2372 199.793C96.9485 200.546 95.9015 199.927 95.9015 198.448C95.9015 196.968 96.9485 195.165 98.2372 194.412C99.5258 193.658 100.573 194.277 100.573 195.757Z",
    fill: "#5C5C5C"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4174 196.426C99.4174 197.179 98.9076 198.067 98.2636 198.443C97.8343 198.685 97.4318 198.632 97.244 198.336C97.405 198.336 97.566 198.282 97.727 198.174C98.3709 197.798 98.8807 196.91 98.8807 196.157C98.8807 195.915 98.8271 195.727 98.7466 195.593C99.1491 195.593 99.4174 195.889 99.4174 196.426Z",
    fill: "#A6A6A6"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8871 196.157C98.8871 196.91 98.3773 197.798 97.7333 198.174C97.5723 198.282 97.3845 198.336 97.2504 198.336C97.1699 198.201 97.1162 198.013 97.1162 197.771C97.1162 197.018 97.626 196.131 98.2699 195.754C98.4578 195.647 98.6188 195.62 98.7529 195.593C98.8334 195.727 98.8871 195.915 98.8871 196.157Z",
    fill: "#4A4A4A"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M111.862 187.488L110.868 186.977C110.466 186.789 109.929 186.842 109.338 187.192C108.049 187.919 107.029 189.748 107.029 191.228C107.029 192.009 107.324 192.547 107.781 192.789L108.452 193.112L108.613 192.87C108.855 192.816 109.096 192.735 109.338 192.574C110.627 191.82 111.674 190.017 111.674 188.538C111.674 188.322 111.647 188.107 111.593 187.946L111.862 187.488Z",
    fill: "#A6A6A6"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M112.432 188.917C112.432 190.397 111.385 192.2 110.096 192.953C108.808 193.706 107.76 193.088 107.76 191.608C107.76 190.128 108.808 188.298 110.096 187.572C111.385 186.818 112.432 187.437 112.432 188.917Z",
    fill: "#5C5C5C"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M111.245 189.587C111.245 190.34 110.735 191.227 110.091 191.603C109.662 191.845 109.26 191.792 109.072 191.496C109.233 191.496 109.394 191.442 109.555 191.335C110.199 190.958 110.709 190.071 110.709 189.318C110.709 189.076 110.655 188.887 110.574 188.753C110.977 188.753 111.245 189.049 111.245 189.587Z",
    fill: "#A6A6A6"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M110.703 189.318C110.703 190.071 110.193 190.958 109.55 191.335C109.389 191.442 109.201 191.496 109.067 191.496C108.986 191.361 108.932 191.173 108.932 190.931C108.932 190.178 109.442 189.291 110.086 188.914C110.247 188.807 110.435 188.753 110.569 188.753C110.65 188.887 110.703 189.076 110.703 189.318Z",
    fill: "#4A4A4A"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M123.684 180.627L122.691 180.116C122.288 179.927 121.751 180.008 121.161 180.331C119.872 181.084 118.825 182.887 118.825 184.367C118.825 185.147 119.12 185.685 119.577 185.928L120.248 186.25L120.409 186.008C120.65 185.955 120.892 185.874 121.134 185.712C122.422 184.959 123.469 183.156 123.469 181.676C123.469 181.461 123.469 181.246 123.389 181.084L123.657 180.627H123.684Z",
    fill: "#A6A6A6"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M124.244 182.049C124.244 183.529 123.197 185.332 121.909 186.085C120.62 186.838 119.573 186.219 119.573 184.74C119.573 183.26 120.62 181.457 121.909 180.704C123.197 179.95 124.244 180.569 124.244 182.049Z",
    fill: "#5C5C5C"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M123.068 182.729C123.068 183.482 122.558 184.37 121.914 184.746C121.485 184.988 121.082 184.934 120.894 184.638C121.028 184.638 121.216 184.585 121.377 184.477C122.021 184.101 122.531 183.213 122.531 182.46C122.531 182.218 122.477 182.03 122.397 181.896C122.799 181.896 123.068 182.191 123.068 182.729Z",
    fill: "#A6A6A6"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M122.523 182.46C122.523 183.213 122.013 184.101 121.369 184.477C121.208 184.585 121.021 184.638 120.886 184.638C120.806 184.504 120.752 184.316 120.752 184.074C120.752 183.321 121.262 182.433 121.906 182.057C122.067 181.949 122.255 181.896 122.389 181.896C122.469 182.03 122.523 182.218 122.523 182.46Z",
    fill: "#4A4A4A"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M135.499 173.793L134.505 173.282C134.103 173.093 133.566 173.147 132.975 173.497C131.687 174.25 130.64 176.053 130.64 177.533C130.64 178.313 130.935 178.851 131.418 179.094L132.089 179.416L132.25 179.174C132.492 179.121 132.734 179.04 132.975 178.878C134.264 178.125 135.311 176.322 135.311 174.842C135.311 174.627 135.311 174.412 135.23 174.25L135.499 173.793Z",
    fill: "#A6A6A6"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M136.059 175.22C136.059 176.7 135.012 178.502 133.723 179.256C132.435 180.009 131.414 179.39 131.414 177.91C131.414 176.431 132.461 174.628 133.723 173.874C135.012 173.121 136.059 173.74 136.059 175.22Z",
    fill: "#5C5C5C"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M134.906 175.891C134.906 176.644 134.396 177.532 133.752 177.908C133.323 178.15 132.921 178.096 132.733 177.801C132.867 177.801 133.055 177.747 133.216 177.639C133.86 177.263 134.37 176.375 134.37 175.622C134.37 175.38 134.316 175.192 134.235 175.058C134.638 175.058 134.906 175.353 134.906 175.891Z",
    fill: "#A6A6A6"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M134.378 175.622C134.378 176.375 133.869 177.263 133.225 177.639C133.064 177.747 132.876 177.801 132.742 177.801C132.661 177.666 132.608 177.478 132.608 177.236C132.608 176.483 133.117 175.595 133.761 175.219C133.949 175.111 134.11 175.058 134.244 175.058C134.325 175.192 134.378 175.38 134.378 175.622Z",
    fill: "#4A4A4A"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M147.329 166.929L146.336 166.417C145.933 166.229 145.396 166.283 144.805 166.633C143.517 167.386 142.47 169.189 142.47 170.669C142.47 171.449 142.765 171.987 143.221 172.202L143.892 172.552L144.054 172.31C144.295 172.256 144.537 172.176 144.805 172.014C146.094 171.261 147.141 169.458 147.141 167.978C147.141 167.763 147.141 167.548 147.06 167.386L147.329 166.929Z",
    fill: "#A6A6A6"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M147.889 168.358C147.889 169.838 146.842 171.641 145.553 172.394C144.265 173.148 143.218 172.529 143.218 171.049C143.218 169.569 144.265 167.767 145.553 167.013C146.842 166.26 147.889 166.879 147.889 168.358Z",
    fill: "#5C5C5C"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M146.734 169.027C146.734 169.78 146.224 170.667 145.58 171.044C145.151 171.286 144.748 171.232 144.56 170.936C144.694 170.936 144.882 170.883 145.043 170.775C145.687 170.398 146.197 169.511 146.197 168.758C146.197 168.516 146.143 168.328 146.063 168.193C146.465 168.193 146.734 168.489 146.734 169.027Z",
    fill: "#A6A6A6"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M146.206 168.758C146.206 169.511 145.696 170.398 145.053 170.775C144.865 170.883 144.704 170.936 144.57 170.936C144.489 170.802 144.435 170.614 144.435 170.372C144.435 169.619 144.945 168.731 145.589 168.355C145.75 168.247 145.938 168.193 146.072 168.193C146.153 168.328 146.206 168.516 146.206 168.758Z",
    fill: "#4A4A4A"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M159.178 160.093L158.185 159.582C157.782 159.393 157.245 159.474 156.654 159.797C155.366 160.523 154.319 162.353 154.319 163.833C154.319 164.613 154.614 165.151 155.07 165.366L155.742 165.689L155.903 165.447C156.144 165.393 156.386 165.313 156.628 165.151C157.916 164.398 158.963 162.595 158.963 161.115C158.963 160.9 158.963 160.685 158.883 160.523L159.151 160.066L159.178 160.093Z",
    fill: "#A6A6A6"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M159.738 161.517C159.738 162.997 158.691 164.799 157.402 165.553C156.114 166.306 155.067 165.687 155.067 164.207C155.067 162.727 156.114 160.925 157.402 160.171C158.691 159.418 159.738 160.037 159.738 161.517Z",
    fill: "#5C5C5C"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M158.585 162.161C158.585 162.914 158.075 163.801 157.431 164.178C157.002 164.42 156.6 164.366 156.412 164.07C156.546 164.07 156.707 164.016 156.895 163.909C157.539 163.532 158.049 162.645 158.049 161.892C158.049 161.65 157.995 161.462 157.914 161.327C158.317 161.327 158.585 161.623 158.585 162.161Z",
    fill: "#A6A6A6"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M158.058 161.892C158.058 162.645 157.548 163.532 156.904 163.909C156.716 164.016 156.555 164.07 156.421 164.07C156.341 163.936 156.287 163.747 156.287 163.505C156.287 162.752 156.797 161.865 157.441 161.489C157.602 161.381 157.79 161.327 157.924 161.327C158.004 161.462 158.058 161.65 158.058 161.892Z",
    fill: "#4A4A4A"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M171.026 153.237L170.032 152.726C169.63 152.538 169.093 152.592 168.502 152.941C167.213 153.695 166.166 155.497 166.166 156.977C166.166 157.758 166.462 158.296 166.945 158.538L167.616 158.861L167.777 158.619C168.019 158.565 168.26 158.484 168.502 158.323C169.791 157.569 170.838 155.767 170.838 154.287C170.838 154.071 170.838 153.856 170.757 153.695L171.026 153.237Z",
    fill: "#A6A6A6"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M171.586 154.666C171.586 156.146 170.539 157.949 169.251 158.702C167.962 159.456 166.915 158.837 166.942 157.357C166.942 155.877 167.989 154.074 169.251 153.321C170.539 152.567 171.586 153.186 171.586 154.666Z",
    fill: "#5C5C5C"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M170.433 155.336C170.433 156.062 169.923 156.976 169.279 157.352C168.85 157.594 168.447 157.541 168.26 157.245C168.421 157.245 168.582 157.191 168.743 157.084C169.387 156.707 169.896 155.82 169.896 155.067C169.896 154.825 169.843 154.636 169.762 154.502C170.165 154.502 170.433 154.798 170.433 155.336Z",
    fill: "#A6A6A6"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M169.905 155.067C169.905 155.82 169.395 156.707 168.752 157.084C168.591 157.191 168.403 157.245 168.269 157.245C168.188 157.11 168.134 156.922 168.134 156.68C168.134 155.927 168.644 155.04 169.288 154.663C169.476 154.556 169.637 154.502 169.771 154.502C169.852 154.636 169.905 154.825 169.905 155.067Z",
    fill: "#4A4A4A"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M182.854 146.4L181.861 145.889C181.458 145.701 180.921 145.755 180.331 146.104C179.042 146.858 177.995 148.661 177.995 150.14C177.995 150.921 178.29 151.459 178.747 151.674L179.418 152.024L179.579 151.782C179.821 151.728 180.062 151.647 180.331 151.486C181.619 150.732 182.666 148.93 182.666 147.45C182.666 147.234 182.64 147.019 182.586 146.858L182.854 146.4Z",
    fill: "#A6A6A6"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M183.414 147.827C183.414 149.307 182.367 151.11 181.079 151.863C179.79 152.617 178.743 151.998 178.743 150.518C178.743 149.038 179.79 147.235 181.079 146.482C182.367 145.728 183.414 146.347 183.414 147.827Z",
    fill: "#5C5C5C"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M182.262 148.467C182.262 149.22 181.752 150.108 181.108 150.484C180.679 150.726 180.276 150.673 180.088 150.377C180.222 150.377 180.41 150.323 180.571 150.215C181.215 149.839 181.725 148.951 181.725 148.199C181.725 147.983 181.671 147.768 181.591 147.634C181.993 147.634 182.262 147.93 182.262 148.467Z",
    fill: "#A6A6A6"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M181.693 148.199C181.693 148.951 181.183 149.839 180.54 150.215C180.352 150.323 180.191 150.377 180.057 150.377C179.976 150.242 179.922 150.054 179.922 149.812C179.922 149.086 180.459 148.172 181.076 147.795C181.237 147.688 181.425 147.634 181.559 147.634C181.64 147.768 181.693 147.956 181.693 148.199Z",
    fill: "#4A4A4A"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M194.708 139.542L193.714 139.031C193.312 138.842 192.775 138.896 192.184 139.246C190.896 139.999 189.849 141.802 189.849 143.282C189.849 144.062 190.144 144.6 190.6 144.816L191.271 145.166L191.432 144.923C191.674 144.87 191.916 144.789 192.184 144.627C193.473 143.874 194.52 142.071 194.52 140.591C194.52 140.376 194.493 140.161 194.439 139.999L194.708 139.542Z",
    fill: "#A6A6A6"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M195.268 140.969C195.268 142.449 194.221 144.251 192.932 145.005C191.644 145.758 190.597 145.139 190.597 143.66C190.597 142.18 191.644 140.377 192.932 139.623C194.221 138.87 195.268 139.489 195.268 140.969Z",
    fill: "#5C5C5C"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M194.091 141.64C194.091 142.393 193.581 143.281 192.937 143.657C192.508 143.899 192.105 143.845 191.918 143.55C192.052 143.55 192.24 143.496 192.401 143.388C193.045 143.012 193.554 142.124 193.554 141.371C193.554 141.156 193.501 140.941 193.42 140.807C193.823 140.807 194.091 141.102 194.091 141.64Z",
    fill: "#A6A6A6"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M193.549 141.369C193.549 142.122 193.039 143.01 192.395 143.386C192.207 143.494 192.046 143.548 191.912 143.548C191.832 143.413 191.778 143.225 191.778 142.983C191.778 142.257 192.288 141.343 192.932 140.966C193.093 140.858 193.281 140.805 193.415 140.805C193.495 140.939 193.549 141.127 193.549 141.369Z",
    fill: "#4A4A4A"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1034 214.126L192.995 137.226L198.66 147.423V205.435L54.4387 288.873L54.4656 230.862L60.1034 214.126Z",
    fill: "url(#paint32_linear_1504_151244)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0474 213.318V215.04L97.2427 206.214V196.689L96.0882 197.362V205.192L82.0474 213.318Z",
    fill: "#344054"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0474 205.516V213.319L96.0882 205.193V197.363L82.0474 205.516Z",
    fill: "url(#paint33_linear_1504_151244)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7844 227.312L78.6107 217.007V207.481L77.4563 208.154V215.957L61.6435 225.105L60.7844 227.312Z",
    fill: "#344054"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6362 225.101L77.449 215.952V208.149L65.4485 215.091L61.6362 225.101Z",
    fill: "url(#paint34_linear_1504_151244)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M175.306 159.346V161.042L193.105 150.736L188.461 143.929L188.112 144.117L191.951 149.714L175.306 159.346Z",
    fill: "#344054"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M175.306 151.544V159.347L191.951 149.715L188.112 144.118L175.306 151.544Z",
    fill: "url(#paint35_linear_1504_151244)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M100.675 202.529V204.251L115.871 195.453V185.928L114.716 186.6V194.403L100.675 202.529Z",
    fill: "#344054"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M100.675 194.725V202.528L114.716 194.402V186.599L100.675 194.725Z",
    fill: "url(#paint36_linear_1504_151244)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M119.284 191.741V193.463L134.506 184.665V175.14L133.352 175.812V183.615L119.284 191.741Z",
    fill: "#344054"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M119.284 183.935V191.738L133.352 183.613V175.81L119.284 183.935Z",
    fill: "url(#paint37_linear_1504_151244)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M137.922 180.952V182.674L153.144 173.876V164.351L151.99 165.023V172.826L137.922 180.952Z",
    fill: "#344054"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M137.922 173.148V180.951L151.99 172.825V165.022L137.922 173.148Z",
    fill: "url(#paint38_linear_1504_151244)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M156.541 170.19V171.912L171.763 163.113V153.562L170.609 154.234V162.064L156.541 170.19Z",
    fill: "#344054"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M156.541 162.387V170.19L170.609 162.064V154.234L156.541 162.387Z",
    fill: "url(#paint39_linear_1504_151244)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0983 212.378L60.1051 214.127L54.4673 230.863L51.4336 229.114L57.0983 212.378Z",
    fill: "url(#paint40_linear_1504_151244)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0927 212.377L189.984 135.477L192.991 137.225L60.0995 214.126L57.0927 212.377Z",
    fill: "url(#paint41_linear_1504_151244)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M172.882 124.371H166.684V130.402H172.882V124.371Z",
    fill: "#FFDAAB"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M169.48 126.105L186.99 135.867V117.85L169.48 108.088V126.105Z",
    fill: "#F5CB95"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M152.545 135.641L169.473 126.105V108.088L152.545 117.586V135.641Z",
    fill: "#D1AD7F"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M190.048 110.084L186.988 117.848L169.479 108.086L172.616 100.321L190.048 110.084Z",
    fill: "#FFDAAB"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M147.589 113.283L152.547 117.58L170.018 127.343L165.021 123.083L147.589 113.283Z",
    fill: "#D1AD7F"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M152.545 135.64L170.016 145.402V127.347L152.545 117.585V135.64Z",
    fill: "#F5CB95"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M170.021 145.402L186.988 135.866V117.849L170.021 127.347V145.402Z",
    fill: "#D1AD7F"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M180.901 128.367L185.743 125.615V120.564L180.901 123.278V128.367Z",
    fill: "#EBEBEB"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M181.6 123.994L185.278 121.922V121.47L181.6 123.542V123.994Z",
    fill: "#9E9E9E"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M181.6 125.233L185.278 123.161V122.709L181.6 124.781V125.233Z",
    fill: "#9E9E9E"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M181.6 126.484L185.278 124.412V123.96L181.6 126.032V126.484Z",
    fill: "#9E9E9E"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M181.6 127.649L183.691 126.481V125.991L181.6 127.159V127.649Z",
    fill: "#9E9E9E"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M171.661 140.081L178.517 136.199V135.596L171.661 139.44V140.081Z",
    fill: "#9C8469"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M171.661 142.156L178.517 138.311V137.708L171.661 141.553V142.156Z",
    fill: "#9C8469"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M171.661 143.248L178.517 139.403V138.763L171.661 142.607V143.248Z",
    fill: "#9C8469"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M171.661 141.091L175.068 139.132V138.529L171.661 140.451V141.091Z",
    fill: "#9C8469"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M180.901 131.682L185.742 128.968V126.557L180.901 129.27V131.682Z",
    fill: "#EBEBEB"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M183.868 129.162L183.984 129.086V127.956L183.868 128.031V129.162Z",
    fill: "#424242"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M185.049 128.487L185.165 128.449V127.319L185.049 127.357V128.487Z",
    fill: "#424242"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M182.248 130.03L182.364 129.992V128.862L182.248 128.938V130.03Z",
    fill: "#424242"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M181.938 130.212L182.053 130.136V129.044L181.938 129.082V130.212Z",
    fill: "#424242"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M185.342 128.293L185.535 128.18V127.088L185.342 127.163V128.293Z",
    fill: "#424242"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M184.118 129.01L184.311 128.897V127.767L184.118 127.88V129.01Z",
    fill: "#424242"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M183.519 129.345L183.558 129.307V128.177L183.519 128.214V129.345Z",
    fill: "#424242"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M184.651 128.704L184.689 128.666V127.536L184.651 127.574V128.704Z",
    fill: "#424242"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M183.297 129.465L183.374 129.427V128.297L183.297 128.335V129.465Z",
    fill: "#424242"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M183.143 129.534H183.181V128.404L183.143 128.442V129.534Z",
    fill: "#424242"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M184.807 128.593H184.846V127.463L184.807 127.501V128.593Z",
    fill: "#424242"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M182.566 129.875L182.604 129.838V128.745H182.566V129.875Z",
    fill: "#424242"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M181.745 130.331H181.783V129.201L181.745 129.239V130.331Z",
    fill: "#424242"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M183.675 129.234L183.753 129.196V128.104H183.675V129.234Z",
    fill: "#424242"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M184.458 128.821L184.496 128.783V127.653L184.458 127.691V128.821Z",
    fill: "#424242"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M182.805 129.768L182.998 129.655V128.524L182.805 128.637V129.768Z",
    fill: "#424242"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M181.322 130.555L181.515 130.48V129.35L181.322 129.463V130.555Z",
    fill: "#424242"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M146.49 139.144H140.292V145.174H146.49V139.144Z",
    fill: "#FFDAAB"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M143.086 140.875L160.596 150.638V132.621L143.086 122.858V140.875Z",
    fill: "#F5CB95"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M126.161 150.412L143.089 140.875V122.858L126.161 132.357V150.412Z",
    fill: "#D1AD7F"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M163.652 124.853L160.591 132.618L143.082 122.855L146.22 115.053L163.652 124.853Z",
    fill: "#FFDAAB"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M121.195 128.056L126.153 132.353L143.624 142.115L138.627 137.856L121.195 128.056Z",
    fill: "#D1AD7F"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M126.161 150.411L143.631 160.174V142.119L126.161 132.356V150.411Z",
    fill: "#F5CB95"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M143.634 160.172L160.601 150.636V132.619L143.634 142.118V160.172Z",
    fill: "#D1AD7F"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M154.51 143.103L159.353 140.389V135.338L154.51 138.052V143.103Z",
    fill: "#EBEBEB"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M155.209 138.767L158.887 136.695V136.243L155.209 138.315V138.767Z",
    fill: "#9E9E9E"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M155.21 140.005L158.888 137.934V137.481L155.21 139.553V140.005Z",
    fill: "#9E9E9E"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M155.21 141.257L158.888 139.185V138.733L155.21 140.805V141.257Z",
    fill: "#9E9E9E"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M155.21 142.421L157.3 141.216V140.764L155.21 141.931V142.421Z",
    fill: "#9E9E9E"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M145.266 154.813L152.123 150.968V150.365L145.266 154.21V154.813Z",
    fill: "#9C8469"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M145.266 156.923L152.123 153.079V152.476L145.266 156.32V156.923Z",
    fill: "#9C8469"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M145.266 158.018L152.123 154.135V153.532L145.266 157.377V158.018Z",
    fill: "#9C8469"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M145.266 155.823L148.673 153.902V153.299L145.266 155.22V155.823Z",
    fill: "#9C8469"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M154.51 146.456L159.351 143.742V141.293L154.51 144.044V146.456Z",
    fill: "#EBEBEB"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M157.488 143.939L157.604 143.864V142.733L157.488 142.809V143.939Z",
    fill: "#424242"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M158.669 143.264L158.785 143.189V142.059L158.669 142.134V143.264Z",
    fill: "#424242"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M155.868 144.812L155.984 144.775V143.645L155.868 143.682V144.812Z",
    fill: "#424242"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M155.558 144.99L155.673 144.914V143.784L155.558 143.86V144.99Z",
    fill: "#424242"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M158.962 143.07L159.155 142.957V141.827L158.962 141.94V143.07Z",
    fill: "#424242"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M157.735 143.787L157.928 143.674V142.544L157.735 142.657V143.787Z",
    fill: "#424242"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M157.109 144.13L157.187 144.092V142.962L157.109 143V144.13Z",
    fill: "#424242"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M158.266 143.491L158.304 143.453V142.323L158.266 142.361V143.491Z",
    fill: "#424242"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M156.916 144.239L156.993 144.201V143.071L156.916 143.109V144.239Z",
    fill: "#424242"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M156.762 144.31H156.801V143.18H156.762V144.31Z",
    fill: "#424242"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M158.424 143.369H158.463V142.239H158.424V143.369Z",
    fill: "#424242"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M156.185 144.656L156.224 144.618V143.488L156.185 143.526V144.656Z",
    fill: "#424242"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M155.367 145.103L155.405 145.065V143.973H155.367V145.103Z",
    fill: "#424242"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M157.295 144.012L157.372 143.974V142.844L157.295 142.881V144.012Z",
    fill: "#424242"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M158.075 143.599L158.113 143.562V142.432L158.075 142.469V143.599Z",
    fill: "#424242"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M156.425 144.506L156.618 144.431V143.301L156.425 143.376V144.506Z",
    fill: "#424242"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M154.941 145.328L155.134 145.252V144.122L154.941 144.197V145.328Z",
    fill: "#424242"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M120.743 154.978L137.672 145.479L120.201 135.717L103.273 145.215L120.743 154.978Z",
    fill: "#FFDAAB"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M127.912 150.952L130.507 149.482L113.036 139.72L110.441 141.152L127.912 150.952Z",
    fill: "#9C805F"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M103.272 163.269L120.743 173.031V154.976L103.272 145.214V163.269Z",
    fill: "#F5CB95"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M120.757 173.032L137.685 163.496V145.479L120.757 154.977V173.032Z",
    fill: "#D1AD7F"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M127.916 156.41L130.511 154.94V149.475L127.916 150.945V156.41Z",
    fill: "#705C44"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M131.636 155.963L136.479 153.249V148.198L131.636 150.912V155.963Z",
    fill: "#EBEBEB"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M132.336 151.628L136.014 149.557V149.104L132.336 151.176V151.628Z",
    fill: "#9E9E9E"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M132.336 152.869L136.014 150.797V150.345L132.336 152.417V152.869Z",
    fill: "#9E9E9E"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M132.336 154.117L136.014 152.045V151.593L132.336 153.665V154.117Z",
    fill: "#9E9E9E"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M132.336 155.173L134.426 154.005V153.553L132.336 154.721V155.173Z",
    fill: "#9E9E9E"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M122.347 167.681L129.243 163.836V163.233L122.347 167.078V167.681Z",
    fill: "#9C8469"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M122.347 169.794L129.243 165.95V165.347L122.347 169.191V169.794Z",
    fill: "#9C8469"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M122.347 170.884L129.243 167.002V166.398L122.347 170.243V170.884Z",
    fill: "#9C8469"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M122.347 168.768L125.793 166.846V166.206L122.347 168.127V168.768Z",
    fill: "#9C8469"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M131.636 159.318L136.478 156.605V154.193L131.636 156.907V159.318Z",
    fill: "#EBEBEB"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M134.589 156.795L134.705 156.72V155.59L134.589 155.665V156.795Z",
    fill: "#424242"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M135.796 156.119L135.912 156.043V154.913L135.796 154.988V156.119Z",
    fill: "#424242"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M133 157.665L133.116 157.627V156.497L133 156.572V157.665Z",
    fill: "#424242"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M132.685 157.85L132.801 157.775V156.645L132.685 156.72V157.85Z",
    fill: "#424242"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M136.087 155.927L136.28 155.814V154.722L136.087 154.797V155.927Z",
    fill: "#424242"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M134.865 156.644L135.058 156.531V155.4L134.865 155.513V156.644Z",
    fill: "#424242"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M134.237 156.978L134.276 156.941V155.811L134.237 155.848V156.978Z",
    fill: "#424242"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M135.359 156.339L135.436 156.301V155.171L135.359 155.209V156.339Z",
    fill: "#424242"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M134.044 157.098L134.082 157.06V155.93L134.044 155.967V157.098Z",
    fill: "#424242"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M133.887 157.168H133.926V156.038L133.887 156.076V157.168Z",
    fill: "#424242"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M135.552 156.227H135.591V155.097L135.552 155.134V156.227Z",
    fill: "#424242"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M133.306 157.509L133.345 157.471V156.341L133.306 156.379V157.509Z",
    fill: "#424242"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M132.494 157.965H132.533V156.835H132.494V157.965Z",
    fill: "#424242"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M134.423 156.865L134.461 156.827V155.697L134.423 155.735V156.865Z",
    fill: "#424242"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M135.205 156.455L135.243 156.417V155.287L135.205 155.325V156.455Z",
    fill: "#424242"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M133.55 157.365L133.743 157.289V156.159L133.55 156.272V157.365Z",
    fill: "#424242"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M132.069 158.189L132.262 158.114V156.983L132.069 157.096V158.189Z",
    fill: "#424242"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2435 167.634L115.172 158.097L97.7013 148.335L80.734 157.871L98.2435 167.634Z",
    fill: "#FFDAAB"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M105.405 163.565L108.001 162.132L90.5297 152.37L87.9343 153.802L105.405 163.565Z",
    fill: "#9C805F"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7365 175.894L98.246 185.656V167.639L80.7365 157.877V175.894Z",
    fill: "#F5CB95"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2487 185.653L115.177 176.154V158.1L98.2487 167.636V185.653Z",
    fill: "#D1AD7F"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M105.422 169.071L108.018 167.601V162.136L105.422 163.568V169.071Z",
    fill: "#705C44"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M109.098 168.621L113.979 165.907V160.818L109.098 163.57V168.621Z",
    fill: "#EBEBEB"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M109.797 164.285L113.514 162.213V161.724L109.797 163.796V164.285Z",
    fill: "#9E9E9E"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M109.797 165.533L113.514 163.461V162.972L109.797 165.044V165.533Z",
    fill: "#9E9E9E"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M109.797 166.772L113.514 164.7V164.248L109.797 166.32V166.772Z",
    fill: "#9E9E9E"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M109.797 167.83L111.888 166.663V166.173L109.797 167.378V167.83Z",
    fill: "#9E9E9E"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8473 180.341L106.704 176.497V175.894L99.8473 179.738V180.341Z",
    fill: "#9C8469"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8473 182.455L106.704 178.61V177.97L99.8473 181.852V182.455Z",
    fill: "#9C8469"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8473 183.508L106.704 179.664V179.061L99.8473 182.905V183.508Z",
    fill: "#9C8469"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8473 181.429L103.293 179.47V178.867L99.8473 180.788V181.429Z",
    fill: "#9C8469"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M109.099 171.976L113.978 169.225V166.813L109.099 169.564V171.976Z",
    fill: "#EBEBEB"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M112.069 169.417L112.185 169.379V168.249L112.069 168.287V169.417Z",
    fill: "#424242"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M113.252 168.78L113.368 168.704V167.574L113.252 167.65V168.78Z",
    fill: "#424242"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M110.485 170.324L110.601 170.248V169.118L110.485 169.194V170.324Z",
    fill: "#424242"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M110.185 170.505L110.3 170.43V169.3L110.185 169.375V170.505Z",
    fill: "#424242"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M113.542 168.586L113.736 168.473V167.343L113.542 167.456V168.586Z",
    fill: "#424242"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M112.318 169.265L112.511 169.19V168.06L112.318 168.173V169.265Z",
    fill: "#424242"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M111.714 169.608H111.753V168.478L111.714 168.515V169.608Z",
    fill: "#424242"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M112.848 169.004L112.887 168.966V167.836L112.848 167.874V169.004Z",
    fill: "#424242"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M111.529 169.717H111.567V168.587L111.529 168.625V169.717Z",
    fill: "#424242"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M111.343 169.824L111.382 169.786V168.693H111.343V169.824Z",
    fill: "#424242"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M113.005 168.886L113.082 168.848V167.718L113.005 167.755V168.886Z",
    fill: "#424242"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M110.764 170.169L110.841 170.131V169.001L110.764 169.039V170.169Z",
    fill: "#424242"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M109.948 170.624L109.986 170.586V169.456L109.948 169.494V170.624Z",
    fill: "#424242"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M111.876 169.527L111.953 169.49V168.359L111.876 168.397V169.527Z",
    fill: "#424242"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M112.658 169.115L112.735 169.077V167.947L112.658 167.985V169.115Z",
    fill: "#424242"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M111.006 170.023L111.199 169.91V168.78L111.006 168.893V170.023Z",
    fill: "#424242"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M109.522 170.848L109.715 170.735V169.604L109.522 169.718V170.848Z",
    fill: "#424242"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7184 179.658L93.647 170.16L76.1762 160.397L59.2477 169.896L76.7184 179.658Z",
    fill: "#FFDAAB"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9259 175.633L86.4826 174.163L69.0118 164.4L66.4163 165.833L83.9259 175.633Z",
    fill: "#9C805F"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2426 187.951L76.7133 197.714V179.659L59.2426 169.896V187.951Z",
    fill: "#F5CB95"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7083 197.716L93.6369 188.18V170.163L76.7083 179.662V197.716Z",
    fill: "#D1AD7F"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9259 181.09L86.4826 179.62V174.154L83.9259 175.624V181.09Z",
    fill: "#705C44"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6064 180.647L92.4487 177.933V172.882L87.6064 175.596V180.647Z",
    fill: "#EBEBEB"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3053 176.311L91.9832 174.239V173.787L88.3053 175.859V176.311Z",
    fill: "#9E9E9E"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3054 177.551L91.9834 175.479V175.027L88.3054 177.099V177.551Z",
    fill: "#9E9E9E"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3054 178.801L91.9834 176.729V176.277L88.3054 178.349V178.801Z",
    fill: "#9E9E9E"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3054 179.857L90.396 178.689V178.237L88.3054 179.405V179.857Z",
    fill: "#9E9E9E"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3427 192.4L85.1992 188.518V187.915L78.3427 191.76V192.4Z",
    fill: "#9C8469"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3425 194.481L85.1991 190.636V190.033L78.3425 193.878V194.481Z",
    fill: "#9C8469"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3427 195.566L85.1992 191.684V191.081L78.3427 194.926V195.566Z",
    fill: "#9C8469"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3427 193.449L81.7497 191.528V190.888L78.3427 192.809V193.449Z",
    fill: "#9C8469"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6066 183.994L92.4477 181.281V178.831L87.6066 181.582V183.994Z",
    fill: "#EBEBEB"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5483 181.471L90.6642 181.396V180.266L90.5483 180.341V181.471Z",
    fill: "#424242"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7511 180.798L91.867 180.722V179.63L91.7511 179.668V180.798Z",
    fill: "#424242"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9573 182.341L89.0731 182.303V181.173L88.9573 181.248V182.341Z",
    fill: "#424242"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6422 182.524L88.7581 182.449V181.318L88.6422 181.394V182.524Z",
    fill: "#424242"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0542 180.603L92.2473 180.49V179.397L92.0542 179.473V180.603Z",
    fill: "#424242"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8221 181.319L91.0152 181.206V180.076L90.8221 180.189V181.319Z",
    fill: "#424242"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1942 181.654L90.2329 181.616V180.486L90.1942 180.524V181.654Z",
    fill: "#424242"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3162 181.014L91.3934 180.976V179.846L91.3162 179.883V181.014Z",
    fill: "#424242"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0011 181.774L90.0396 181.737V180.606L90.0011 180.644V181.774Z",
    fill: "#424242"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8472 181.845H89.8858V180.715H89.8472V181.845Z",
    fill: "#424242"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5092 180.903H91.5478V179.772H91.5092V180.903Z",
    fill: "#424242"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2653 182.182L89.3038 182.145V181.015L89.2653 181.052V182.182Z",
    fill: "#424242"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4517 182.641L88.4903 182.603V181.511H88.4517V182.641Z",
    fill: "#424242"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3798 181.543L90.4184 181.505V180.375L90.3798 180.413V181.543Z",
    fill: "#424242"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1327 181.131L91.21 181.093V179.963L91.1327 180.001V181.131Z",
    fill: "#424242"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5098 182.039L89.7028 181.963V180.833L89.5098 180.946V182.039Z",
    fill: "#424242"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0262 182.865L88.2193 182.752V181.659L88.0262 181.772V182.865Z",
    fill: "#424242"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5922 192.207L71.5207 182.671L54.0499 172.908L37.1213 182.444L54.5922 192.207Z",
    fill: "#FFDAAB"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7608 188.144L64.3562 186.674L46.8854 176.911L44.2899 178.381L61.7608 188.144Z",
    fill: "#9C805F"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1193 200.461L54.5901 210.224V192.207L37.1193 182.444V200.461Z",
    fill: "#F5CB95"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5847 210.227L71.5132 200.691V182.674L54.5847 192.21V210.227Z",
    fill: "#D1AD7F"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7584 193.605L64.3538 192.173V186.67L61.7584 188.14V193.605Z",
    fill: "#705C44"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4679 193.194L70.3101 190.48V185.392L65.4679 188.105V193.194Z",
    fill: "#EBEBEB"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1326 188.859L69.8493 186.75V186.298L66.1326 188.37V188.859Z",
    fill: "#9E9E9E"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1326 190.099L69.8493 187.989V187.537L66.1326 189.609V190.099Z",
    fill: "#9E9E9E"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1327 191.349L69.8494 189.277V188.787L66.1327 190.859V191.349Z",
    fill: "#9E9E9E"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1327 192.405L68.262 191.199V190.747L66.1327 191.915V192.405Z",
    fill: "#9E9E9E"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1857 204.911L63.0423 201.067V200.426L56.1857 204.308V204.911Z",
    fill: "#9C8469"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1857 207.024L63.0423 203.142V202.539L56.1857 206.384V207.024Z",
    fill: "#9C8469"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1857 208.078L63.0423 204.234V203.593L56.1857 207.475V208.078Z",
    fill: "#9C8469"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1857 205.969L59.6313 204.048V203.445L56.1857 205.367V205.969Z",
    fill: "#9C8469"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4678 196.51L70.3089 193.797V191.385L65.4678 194.098V196.51Z",
    fill: "#EBEBEB"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4122 193.986L68.5281 193.91V192.78L68.4122 192.856V193.986Z",
    fill: "#424242"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5565 193.312L69.7111 193.275V192.145L69.5565 192.22V193.312Z",
    fill: "#424242"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8192 194.893L66.9351 194.818V193.688L66.8192 193.763V194.893Z",
    fill: "#424242"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5061 195.036L66.622 194.998V193.868L66.5061 193.906V195.036Z",
    fill: "#424242"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9108 193.118L70.104 193.042V191.912L69.9108 192.025V193.118Z",
    fill: "#424242"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6862 193.834L68.8792 193.721V192.591L68.6862 192.704V193.834Z",
    fill: "#424242"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0581 194.177H68.0967V193.047H68.0581V194.177Z",
    fill: "#424242"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1799 193.535L69.2573 193.498V192.405H69.1799V193.535Z",
    fill: "#424242"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M67.865 194.289L67.9037 194.251V193.121L67.865 193.159V194.289Z",
    fill: "#424242"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7111 194.396L67.7496 194.359V193.229L67.7111 193.266V194.396Z",
    fill: "#424242"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3729 193.455L69.4116 193.417V192.287L69.3729 192.325V193.455Z",
    fill: "#424242"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1342 194.7H67.1728V193.57H67.1342V194.7Z",
    fill: "#424242"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2859 195.193L66.3632 195.156V194.025L66.2859 194.063V195.193Z",
    fill: "#424242"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2439 194.058H68.2826V192.928L68.2439 192.965V194.058Z",
    fill: "#424242"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9966 193.645L69.0738 193.608V192.478L68.9966 192.515V193.645Z",
    fill: "#424242"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3737 194.593L67.5669 194.48V193.35L67.3737 193.463V194.593Z",
    fill: "#424242"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8901 195.417L66.0832 195.304V194.174L65.8901 194.287V195.417Z",
    fill: "#424242"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M106.911 115.773C106.911 115.773 109.894 117.243 117.06 118.11C120.005 119.392 118.571 125.084 116.518 125.008C115.356 125.008 112.179 124.97 104.703 124.707C104.199 123.161 106.872 115.811 106.872 115.811L106.911 115.773Z",
    fill: "#F0C6B4"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7444 114.266C98.7444 114.266 102.851 110.685 106.763 114.379C109.746 117.206 108.429 123.236 105.252 125.083C100.1 128.061 97.1561 123.538 97.1561 123.538L98.7444 114.228V114.266Z",
    fill: "#DC6803"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9884 74.944C76.1174 78.6002 80.2236 93.0742 80.2236 93.0742C80.2236 93.0742 84.9884 120.175 87.8937 122.098C90.7991 124.02 101.452 125.339 102.537 124.321C103.583 123.341 105.403 117.876 103.389 114.747C102.266 112.976 94.4017 112.75 95.099 112.712C96.2998 103.628 92.9296 88.9657 92.9296 88.9657C92.9296 88.9657 92 73.0217 84.9884 74.944Z",
    fill: "#CF7C00"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M142.72 116.535L125.476 126.202L132.186 104.683L148.645 95.7822L142.72 116.535Z",
    fill: "#1C1919"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M142.057 115.219L128.23 122.461L133.498 105.343L146.665 98.1006L142.057 115.219Z",
    fill: "#1C1919"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M116.186 118.171C116.186 118.171 120.834 115.457 122.616 115.193C127.381 114.289 126.916 117.04 126.916 117.04C126.916 117.04 133.889 117.116 134.237 118.661C135.477 123.976 130.519 126.011 127.226 126.388C121.996 126.953 116.147 125.106 116.147 125.106V118.209L116.186 118.171Z",
    fill: "#292929"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M211.772 319.993C210.345 319.514 208.77 319.13 207.146 318.891V314.221H197.991V318.867C196.367 319.107 194.817 319.466 193.365 319.969L187.558 316.712L180.692 320.567L186.696 323.944C186.032 324.639 185.491 325.405 185.122 326.172H176.755V331.848H185.122C185.491 332.638 186.032 333.381 186.696 334.075L180.692 337.452L187.558 341.308L193.365 338.027C194.817 338.53 196.367 338.889 197.991 339.129V343.799H207.146V339.153C208.794 338.913 210.345 338.53 211.772 338.051L217.579 341.332L224.445 337.476L218.441 334.099C219.105 333.405 219.647 332.638 220.016 331.872H228.382V326.196H220.016C219.647 325.405 219.105 324.663 218.441 323.968L224.445 320.591L217.579 316.735L211.772 319.993ZM211.624 327.8C212.461 330.076 210.788 332.519 207.343 333.74C204.439 334.77 200.698 334.77 197.795 333.74C195.58 332.95 194.054 331.704 193.513 330.219C193.119 329.189 193.242 328.136 193.808 327.154C194.522 325.956 195.9 324.974 197.795 324.28C200.698 323.25 204.439 323.25 207.343 324.28C209.557 325.07 211.083 326.316 211.624 327.8Z",
    fill: "#7A2E0E"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M227.441 324.372L217.868 323.126L223.651 319.893V313.499L211.445 317.187C210.067 316.708 208.566 315.654 206.967 315.415V313.762H198.157V315.415C196.582 315.654 195.081 316.708 193.703 317.187L181.498 313.475V319.869L187.28 323.126C186.641 323.797 185.189 322.552 184.844 323.318L177.708 324.372V330.767H181.498V336.155L188.117 339.868L193.728 336.706C195.13 337.185 196.607 337.544 198.182 337.76V342.239H206.991V337.76C208.566 337.52 210.067 337.161 211.47 336.682L217.081 339.844L223.7 336.131V330.743H227.49V325.258V324.348L227.441 324.372ZM207.164 329.785C204.358 330.79 200.766 330.79 197.96 329.785C195.819 329.018 194.343 330.599 193.826 329.186C193.457 328.204 193.555 327.174 194.121 326.216C194.81 325.066 196.139 324.108 197.96 323.462C200.766 322.456 204.358 322.456 207.164 323.462C209.305 324.228 210.756 325.426 211.298 326.839C212.11 329.042 210.486 328.587 207.164 329.785Z",
    fill: "#CF7C00"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M211.419 312.926C210.041 312.447 208.54 312.112 206.94 311.872V307.394H198.13V311.872C196.556 312.112 195.054 312.447 193.676 312.926L188.066 309.789L181.446 313.501L187.229 316.758C186.589 317.429 186.073 318.147 185.703 318.914H177.657V324.398H185.703C186.073 325.164 186.565 325.883 187.229 326.554L181.446 329.787L188.066 333.499L193.676 330.338C195.079 330.817 196.556 331.176 198.13 331.391V335.87H206.94V331.391C208.515 331.152 210.016 330.793 211.419 330.338L217.029 333.475L223.649 329.763L217.866 326.506C218.506 325.835 219.023 325.117 219.367 324.35H227.439V318.866H219.392C219.023 318.099 218.531 317.381 217.866 316.71L223.649 313.477L217.029 309.765L211.419 312.902V312.926ZM211.271 320.446C212.083 322.65 210.459 324.997 207.137 326.17C204.332 327.176 200.739 327.176 197.934 326.17C195.793 325.404 194.316 324.206 193.799 322.769C193.43 321.788 193.529 320.758 194.095 319.8C194.784 318.65 196.113 317.692 197.934 317.021C200.739 316.016 204.332 316.016 207.137 317.021C209.278 317.788 210.73 318.985 211.271 320.398V320.446Z",
    fill: "#FF9800"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M91.846 332.375C90.4188 331.896 88.8439 331.513 87.2197 331.274V326.604H78.0656V331.25C76.4414 331.489 74.8911 331.849 73.4393 332.352L67.6318 329.094L60.7661 332.95L66.7705 336.327C66.1061 337.022 65.5647 337.788 65.1956 338.555H56.8289V344.231H65.1956C65.5647 345.021 66.1061 345.764 66.7705 346.458L60.7661 349.835L67.6318 353.691L73.4393 350.41C74.8911 350.913 76.4414 351.272 78.0656 351.512V356.182H87.2197V351.535C88.8685 351.296 90.4188 350.913 91.846 350.434L97.6535 353.715L104.519 349.859L98.5148 346.482C99.1792 345.787 99.7206 345.021 100.09 344.255H108.456V338.579H100.09C99.7206 337.788 99.1792 337.046 98.5148 336.351L104.519 332.974L97.6535 329.118L91.846 332.375ZM91.6984 340.183C92.5351 342.458 90.8617 344.901 87.4166 346.123C84.5129 347.153 80.7725 347.153 77.8687 346.123C75.654 345.332 74.1283 344.087 73.5869 342.602C73.1932 341.572 73.3162 340.518 73.8822 339.537C74.5958 338.339 75.9739 337.357 77.8687 336.663C80.7725 335.633 84.5129 335.633 87.4166 336.663C89.6313 337.453 91.157 338.698 91.6984 340.183Z",
    fill: "#7A2E0E"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M107.517 336.758L97.9447 335.512L103.728 332.279V325.884L91.522 329.573C90.144 329.094 88.6429 328.04 87.0433 327.8V326.148H78.2337V327.8C76.6588 328.04 75.1577 329.094 73.7796 329.573L61.5741 325.86V332.255L67.3569 335.512C66.7171 336.183 65.2653 334.937 64.9208 335.704L57.7844 336.758V343.152H61.5741V348.541L68.1936 352.253L73.8042 349.092C75.2069 349.571 76.6834 349.93 78.2583 350.146V354.624H87.068V350.146C88.6429 349.906 90.144 349.547 91.5466 349.068L97.1572 352.229L103.777 348.517V343.128H107.566V337.644V336.734L107.517 336.758ZM87.2402 342.17C84.4349 343.176 80.8421 343.176 78.0368 342.17C75.8959 341.404 74.4194 342.985 73.9027 341.572C73.5336 340.59 73.632 339.56 74.198 338.602C74.887 337.452 76.2158 336.494 78.0368 335.848C80.8421 334.842 84.4349 334.842 87.2402 335.848C89.3811 336.614 90.833 337.811 91.3744 339.224C92.1864 341.428 90.5623 340.973 87.2402 342.17Z",
    fill: "#CF7C00"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5271 325.312C90.149 324.833 88.6479 324.497 87.0484 324.258V319.779H78.2388V324.258C76.6638 324.497 75.1627 324.833 73.7847 325.312L68.1741 322.174L61.5545 325.887L67.3374 329.144C66.6976 329.814 66.1808 330.533 65.8117 331.299H57.7649V336.784H65.8117C66.1808 337.55 66.673 338.269 67.3374 338.939L61.5545 342.173L68.1741 345.885L73.7847 342.723C75.1873 343.202 76.6638 343.562 78.2388 343.777V348.256H87.0484V343.777C88.6233 343.538 90.1244 343.178 91.5271 342.723L97.1377 345.861L103.757 342.149L97.9744 338.891C98.6142 338.221 99.1309 337.502 99.4755 336.736H107.547V331.251H99.5001C99.1309 330.485 98.6388 329.766 97.9744 329.096L103.757 325.863L97.1377 322.15L91.5271 325.288V325.312ZM91.3794 332.832C92.1915 335.035 90.5674 337.383 87.2453 338.556C84.44 339.562 80.8472 339.562 78.0419 338.556C75.901 337.79 74.4245 336.592 73.9077 335.155C73.5386 334.173 73.637 333.143 74.203 332.185C74.892 331.036 76.2209 330.078 78.0419 329.407C80.8472 328.401 84.44 328.401 87.2453 329.407C89.3862 330.174 90.8381 331.371 91.3794 332.784V332.832Z",
    fill: "#FF9800"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M165.349 354.979C162.888 354.141 160.181 353.494 157.351 353.087V345.063H141.577V353.087C138.772 353.494 136.09 354.141 133.58 354.979L123.564 349.351L111.752 355.985L122.088 361.781C120.931 362.978 119.996 364.295 119.381 365.637H104.985V375.432H119.381C120.021 376.797 120.931 378.067 122.088 379.288L111.777 385.084L123.589 391.718L133.604 386.09C136.09 386.928 138.772 387.575 141.602 387.982V396.005H157.376V387.982C160.205 387.551 162.888 386.928 165.373 386.09L175.389 391.718L187.2 385.084L176.865 379.288C178.022 378.091 178.932 376.797 179.572 375.432H193.992V365.637H179.597C178.957 364.271 178.046 363.002 176.89 361.781L187.225 355.985L175.413 349.351L165.398 354.979H165.349ZM165.102 368.439C166.554 372.366 163.651 376.558 157.72 378.689C152.725 380.486 146.253 380.486 141.257 378.689C137.443 377.324 134.81 375.169 133.875 372.63C133.21 370.858 133.407 369.037 134.392 367.337C135.622 365.253 137.984 363.553 141.257 362.379C146.253 360.583 152.725 360.583 157.72 362.379C161.534 363.744 164.167 365.9 165.102 368.439Z",
    fill: "#7A2E0E"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M192.35 362.5L175.863 360.369L185.829 354.788V343.771L164.789 350.142C162.402 349.328 159.818 347.508 157.087 347.101V344.25H141.904V347.101C139.197 347.508 136.613 349.328 134.201 350.142L113.161 343.771V354.788L123.103 360.393C121.971 361.566 119.51 359.411 118.895 360.704L106.591 362.524V373.541H113.137V382.834L124.53 389.229L134.177 383.792C136.588 384.606 139.147 385.229 141.879 385.612V393.348H157.062V385.636C159.794 385.229 162.353 384.606 164.764 383.816L174.411 389.253L185.804 382.858V373.565H192.35V364.129V362.548V362.5ZM157.407 371.841C152.583 373.565 146.358 373.565 141.559 371.841C137.868 370.524 135.333 373.254 134.447 370.811C133.808 369.111 133.98 367.338 134.964 365.71C136.145 363.722 138.434 362.069 141.559 360.944C146.382 359.219 152.608 359.219 157.431 360.944C161.122 362.261 163.632 364.345 164.543 366.763C165.946 370.548 163.14 369.781 157.431 371.841H157.407Z",
    fill: "#CF7C00"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M164.764 342.788C162.377 341.974 159.794 341.375 157.062 340.968V333.232H141.879V340.968C139.172 341.375 136.588 341.974 134.177 342.788L124.53 337.352L113.137 343.746L123.078 349.351C121.946 350.524 121.085 351.77 120.47 353.063H106.591V362.499H120.47C121.085 363.793 121.971 365.038 123.078 366.212L113.137 371.792L124.53 378.187L134.177 372.75C136.588 373.564 139.147 374.187 141.879 374.57V382.306H157.062V374.594C159.794 374.187 162.353 373.588 164.764 372.774L174.411 378.211L185.804 371.816L175.863 366.236C176.97 365.062 177.856 363.841 178.471 362.523H192.35V353.087H178.471C177.856 351.794 176.97 350.548 175.863 349.375L185.829 343.794L174.435 337.4L164.789 342.812L164.764 342.788ZM164.518 355.769C165.921 359.554 163.116 363.601 157.407 365.637C152.583 367.361 146.358 367.361 141.559 365.637C137.868 364.32 135.333 362.236 134.447 359.793C133.808 358.093 133.98 356.32 134.964 354.692C136.145 352.704 138.434 351.051 141.559 349.926C146.382 348.201 152.608 348.201 157.431 349.926C161.122 351.243 163.632 353.327 164.543 355.745L164.518 355.769Z",
    fill: "#FF9800"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M477.989 330.838L340.434 410.263L283.104 377.16L420.659 297.734L477.989 330.838Z",
    fill: "black"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M421.157 301.315L433.766 308.591L438.49 305.886L425.881 298.61L421.157 301.315Z",
    fill: "#458FFF"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M421.157 304.054L433.766 311.33V308.587L421.157 301.312V304.054Z",
    fill: "#2565C4"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M429.844 306.345L434.605 303.602V172.521L429.844 175.226V306.345Z",
    fill: "url(#paint42_linear_1504_151244)"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M425.075 303.603L429.837 306.346V175.227L425.075 172.484V303.603Z",
    fill: "#2565C4"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M425.075 172.481L429.837 175.224L434.599 172.519L429.837 169.776L425.075 172.481Z",
    fill: "#458FFF"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M433.766 311.333L438.489 308.629V305.887L433.766 308.591V311.333Z",
    fill: "#1C4B94"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M454.727 320.706L467.336 327.981L472.059 325.239L459.451 317.963L454.727 320.706Z",
    fill: "url(#paint43_linear_1504_151244)"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M454.727 323.443L467.336 330.719V327.976L454.727 320.7V323.443Z",
    fill: "#2565C4"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M454.727 323.443L467.336 330.719V327.976L454.727 320.7V323.443Z",
    fill: "url(#paint44_linear_1504_151244)"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M463.37 325.697L468.132 322.954V191.874L463.37 194.579V325.697Z",
    fill: "url(#paint45_linear_1504_151244)"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M458.645 322.955L463.369 325.698V194.58L458.645 191.837V322.955Z",
    fill: "url(#paint46_linear_1504_151244)"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M458.645 191.834L463.369 194.576L468.13 191.872L463.369 189.129L458.645 191.834Z",
    fill: "url(#paint47_linear_1504_151244)"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M467.337 330.723L472.059 327.981V325.239L467.337 327.981V330.723Z",
    fill: "#596478"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M471.894 280.214L344.129 354.002L290.837 323.26L418.64 249.473L471.894 280.214Z",
    fill: "url(#paint48_linear_1504_151244)"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M471.891 288.445L344.126 362.233V354.004L471.891 280.217V288.445Z",
    fill: "#FF9800"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M471.891 285.847L344.126 359.597V356.359L471.891 282.609V285.847Z",
    fill: "#CC7900"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M344.13 362.227L290.837 331.485V323.257L344.13 353.998V362.227Z",
    fill: "#CF7C00"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M434.558 243.341L414.102 255.15L392.999 243.037L413.455 231.228L434.558 243.341Z",
    fill: "#FFDAAB"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M434.558 243.341L414.102 255.15L392.999 243.037L413.455 231.228L434.558 243.341Z",
    fill: "url(#paint49_linear_1504_151244)"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M425.907 248.297L422.784 250.126L401.68 238.012L404.804 236.184L425.907 248.297Z",
    fill: "#9C805F"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M414.105 277.51L393.001 265.396V243.035L414.105 255.149V277.51Z",
    fill: "#D1AD7F"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M434.569 265.702L414.113 277.511V255.15L434.569 243.341V265.702Z",
    fill: "#D1AD7F"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M425.921 255.114L422.797 256.904V250.123L425.921 248.295V255.114Z",
    fill: "#705C44"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M433.126 252.982L427.26 256.372V250.087L433.126 246.696V252.982Z",
    fill: "#EBEBEB"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M432.556 248.414L428.101 251.004V250.394L432.556 247.843V248.414Z",
    fill: "#9E9E9E"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M432.556 249.971L428.101 252.522V251.951L432.556 249.361V249.971Z",
    fill: "#9E9E9E"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M432.556 251.493L428.101 254.083V253.474L432.556 250.922V251.493Z",
    fill: "#9E9E9E"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M424.318 266.163L416.052 270.925V270.163L424.318 265.363V266.163Z",
    fill: "#9C8469"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M424.318 268.751L416.052 273.513V272.751L424.318 267.989V268.751Z",
    fill: "#9C8469"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M424.318 270.084L416.052 274.846V274.084L424.318 269.322V270.084Z",
    fill: "#9C8469"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M424.32 267.457L420.206 269.856V269.095L424.32 266.695V267.457Z",
    fill: "#9C8469"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M433.126 257.131L427.26 260.521V257.511L433.126 254.121V257.131Z",
    fill: "#EBEBEB"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M430.997 257.278L430.845 257.354V255.945L430.997 255.869V257.278Z",
    fill: "#424242"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M432.402 256.445L432.25 256.559V255.15L432.402 255.074V256.445Z",
    fill: "#424242"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M429.042 258.387L428.89 258.463V257.093L429.042 256.979V258.387Z",
    fill: "#424242"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M428.668 258.618L428.516 258.694V257.285L428.668 257.209V258.618Z",
    fill: "#424242"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M432.855 256.176L432.627 256.329V254.92L432.855 254.768V256.176Z",
    fill: "#424242"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M431.379 257.053L431.15 257.167V255.797L431.379 255.645V257.053Z",
    fill: "#424242"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M430.455 257.583H430.417V256.213L430.455 256.175V257.583Z",
    fill: "#424242"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M431.836 256.785L431.798 256.823V255.414L431.836 255.376V256.785Z",
    fill: "#424242"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M430.237 257.703L430.161 257.741V256.332H430.237V257.703Z",
    fill: "#424242"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M429.998 257.812L429.96 257.85V256.48L429.998 256.441V257.812Z",
    fill: "#424242"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M432.058 256.674L431.981 256.712V255.304L432.058 255.266V256.674Z",
    fill: "#424242"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M429.319 258.23L429.28 258.268V256.859L429.319 256.821V258.23Z",
    fill: "#424242"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M428.324 258.802L428.286 258.84V257.432L428.324 257.394V258.802Z",
    fill: "#424242"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M430.689 257.434L430.613 257.472V256.102L430.689 256.025V257.434Z",
    fill: "#424242"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M431.61 256.897L431.534 256.935V255.564L431.61 255.526V256.897Z",
    fill: "#424242"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M429.775 257.969L429.547 258.083V256.713L429.775 256.561V257.969Z",
    fill: "#424242"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M427.981 258.995L427.753 259.109V257.738L427.981 257.586V258.995Z",
    fill: "#424242"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M393.008 243.035L414.112 255.149V277.51H395.522L374.418 265.396L393.008 254.654V243.035Z",
    fill: "black"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M463.216 281.822L442.988 293.517L422.151 281.517L442.379 269.86L463.216 281.822Z",
    fill: "#0D0D0D"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M460.821 262.315L442.955 272.638L424.556 262.048L442.422 251.763L460.821 262.315Z",
    fill: "#FFDAAB"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M460.821 262.315L442.955 272.638L424.556 262.048L442.422 251.763L460.821 262.315Z",
    fill: "url(#paint50_linear_1504_151244)"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M453.272 266.658L450.53 268.258L432.131 257.668L434.835 256.106L453.272 266.658Z",
    fill: "#9C805F"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M442.955 292.14L424.556 281.588V262.046L442.955 272.636V292.14Z",
    fill: "#F5CB95"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M460.812 281.855L442.946 292.141V272.637L460.812 262.313V281.855Z",
    fill: "#D1AD7F"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M453.27 272.6L450.528 274.162V268.257L453.27 266.657V272.6Z",
    fill: "#705C44"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M459.54 270.765L454.397 273.698V268.213L459.54 265.241V270.765Z",
    fill: "#EBEBEB"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M459.038 266.728L455.116 268.975V268.479L459.038 266.232V266.728Z",
    fill: "#9E9E9E"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M459.038 268.095L455.116 270.342V269.809L459.038 267.6V268.095Z",
    fill: "#9E9E9E"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M459.038 269.436L455.116 271.683V271.187L459.038 268.94V269.436Z",
    fill: "#9E9E9E"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M451.899 282.242L444.662 286.394V285.747L451.899 281.557V282.242Z",
    fill: "#9C8469"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M451.899 284.486L444.662 288.677V287.991L451.899 283.839V284.486Z",
    fill: "#9C8469"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M451.899 285.672L444.662 289.824V289.177L451.899 284.986V285.672Z",
    fill: "#9C8469"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M459.539 274.353L454.397 277.324V274.696L459.539 271.726V274.353Z",
    fill: "#EBEBEB"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M457.629 274.505L457.514 274.582V273.363L457.629 273.287V274.505Z",
    fill: "#424242"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M458.882 273.785L458.768 273.861V272.643L458.882 272.566V273.785Z",
    fill: "#424242"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M455.947 275.46L455.833 275.536V274.317L455.947 274.241V275.46Z",
    fill: "#424242"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M455.656 275.653L455.542 275.729V274.511L455.656 274.435V275.653Z",
    fill: "#424242"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M459.296 273.553L459.105 273.668V272.449L459.296 272.335V273.553Z",
    fill: "#424242"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M457.971 274.275L457.781 274.427V273.209L457.971 273.057V274.275Z",
    fill: "#424242"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M457.207 274.777H457.13V273.559L457.207 273.521V274.777Z",
    fill: "#424242"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M458.386 274.051L458.348 274.089V272.871L458.386 272.833V274.051Z",
    fill: "#424242"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M456.985 274.885H456.947V273.667H456.985V274.885Z",
    fill: "#424242"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M456.828 274.96L456.752 274.999V273.78L456.828 273.742V274.96Z",
    fill: "#424242"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M458.586 273.97H458.548V272.752H458.586V273.97Z",
    fill: "#424242"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M456.186 275.308L456.148 275.346V274.128H456.186V275.308Z",
    fill: "#424242"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M455.338 275.836H455.3V274.617H455.338V275.836Z",
    fill: "#424242"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M457.41 274.618L457.333 274.656V273.437L457.41 273.399V274.618Z",
    fill: "#424242"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M458.201 274.162L458.125 274.2V272.981L458.201 272.943V274.162Z",
    fill: "#424242"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M456.6 275.077L456.41 275.229V274.011L456.6 273.896V275.077Z",
    fill: "#424242"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M455.041 275.995L454.85 276.109V274.891L455.041 274.776V275.995Z",
    fill: "#424242"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M441.793 293.74L407.547 313.511L372.197 293.245L406.481 273.475L441.793 293.74Z",
    fill: "#0D0D0D"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M438.285 260.293L407.467 278.044L375.736 259.798L406.515 242.046L438.285 260.293Z",
    fill: "url(#paint51_linear_1504_151244)"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M425.261 267.759L420.537 270.463L388.767 252.216L393.491 249.512L425.261 267.759Z",
    fill: "#9C805F"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M407.477 311.721L375.745 293.474V259.799L407.477 278.046V311.721Z",
    fill: "#F5CB95"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M438.3 293.96L407.482 311.712V278.037L438.3 260.285V293.96Z",
    fill: "url(#paint52_linear_1504_151244)"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M425.265 277.967L420.541 280.71V270.462L425.265 267.758V277.967Z",
    fill: "#705C44"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M436.097 274.803L427.297 279.869V270.422L436.097 265.317V274.803Z",
    fill: "#EBEBEB"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M435.267 267.903L428.524 271.75V270.874L435.267 267.026V267.903Z",
    fill: "#9E9E9E"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M435.267 270.234L428.524 274.119V273.205L435.267 269.357V270.234Z",
    fill: "#9E9E9E"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M435.267 272.553L428.524 276.438V275.562L435.267 271.677V272.553Z",
    fill: "#9E9E9E"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M422.873 294.616L410.417 301.778V300.635L422.873 293.436V294.616Z",
    fill: "#9C8469"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M422.873 298.5L410.417 305.7V304.557L422.873 297.357V298.5Z",
    fill: "#9C8469"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M422.873 300.522L410.417 307.721V306.541L422.873 299.379V300.522Z",
    fill: "#9C8469"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M436.097 281.019L427.297 286.124V281.629L436.097 276.524V281.019Z",
    fill: "#EBEBEB"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M432.858 281.243L432.668 281.396V279.264L432.858 279.149V281.243Z",
    fill: "#424242"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M434.989 280.026L434.799 280.14V278.046L434.989 277.932V280.026Z",
    fill: "#424242"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M429.959 282.918L429.769 283.07V280.938L429.959 280.824V282.918Z",
    fill: "#424242"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M429.423 283.269L429.195 283.383V281.289L429.423 281.175V283.269Z",
    fill: "#424242"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M435.711 279.609L435.369 279.799V277.705L435.711 277.515V279.609Z",
    fill: "#424242"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M433.46 280.906L433.117 281.097V279.003L433.46 278.812V280.906Z",
    fill: "#424242"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M432.099 281.708L432.023 281.746V279.652L432.099 279.614V281.708Z",
    fill: "#424242"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M434.149 280.521L434.073 280.559V278.465L434.149 278.427V280.521Z",
    fill: "#424242"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M431.747 281.891L431.671 281.967V279.835L431.747 279.797V281.891Z",
    fill: "#424242"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M431.409 282.085L431.333 282.123V280.029L431.409 279.991V282.085Z",
    fill: "#424242"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M434.508 280.33L434.393 280.368V278.274L434.508 278.236V280.33Z",
    fill: "#424242"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M430.376 282.696L430.3 282.735V280.641L430.376 280.603V282.696Z",
    fill: "#424242"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M428.9 283.569L428.824 283.607V281.513L428.9 281.437V283.569Z",
    fill: "#424242"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M432.428 281.514L432.313 281.552V279.458L432.428 279.382V281.514Z",
    fill: "#424242"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M433.85 280.711L433.736 280.749V278.655L433.85 278.579V280.711Z",
    fill: "#424242"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M431.065 282.313L430.722 282.503V280.409L431.065 280.181V282.313Z",
    fill: "#424242"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M428.401 283.834L428.058 284.025V281.931L428.401 281.74V283.834Z",
    fill: "#424242"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M403.178 315.638L353.276 344.398L329.734 330.875L379.636 302.114L403.178 315.638Z",
    fill: "#0D0D0D"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M400.967 291.941L353.388 319.369L330.913 306.455L378.53 279.027L400.967 291.941Z",
    fill: "url(#paint53_linear_1504_151244)"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M378.839 304.776L375.524 306.681L353.049 293.805L356.364 291.862L378.839 304.776Z",
    fill: "#9C805F"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M353.392 343.173L330.917 330.298V306.451L353.392 319.365V343.173Z",
    fill: "url(#paint54_linear_1504_151244)"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M400.977 315.751L353.398 343.178V319.37L400.977 291.942V315.751Z",
    fill: "url(#paint55_linear_1504_151244)"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M378.766 311.977L375.452 313.882V306.644L378.766 304.739V311.977Z",
    fill: "#705C44"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M399.431 302.189L393.183 305.808V299.103L399.431 295.522V302.189Z",
    fill: "#EBEBEB"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M398.814 297.317L394.054 300.059V299.45L398.814 296.708V297.317Z",
    fill: "#9E9E9E"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M398.814 298.991L394.054 301.695V301.086L398.814 298.344V298.991Z",
    fill: "#9E9E9E"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M398.814 300.628L394.054 303.37V302.723L398.814 299.98V300.628Z",
    fill: "#9E9E9E"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M367.861 328.129L359.061 333.234V332.396L367.861 327.329V328.129Z",
    fill: "#9C8469"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M367.861 330.912L359.062 335.979V335.179L367.861 330.074V330.912Z",
    fill: "#9C8469"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M367.861 332.317L359.062 337.421V336.583L367.861 331.479V332.317Z",
    fill: "#9C8469"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M399.551 306.954L393.342 310.573V307.373L399.551 303.792V306.954Z",
    fill: "#EBEBEB"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M397.265 307.146L397.113 307.222V305.737L397.265 305.661V307.146Z",
    fill: "#424242"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M398.795 306.266L398.643 306.342V304.857L398.795 304.781V306.266Z",
    fill: "#424242"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M395.25 308.322L395.06 308.398V306.913L395.25 306.837V308.322Z",
    fill: "#424242"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M394.826 308.552L394.673 308.628V307.143L394.826 307.067V308.552Z",
    fill: "#424242"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M399.282 305.963L399.054 306.116V304.631L399.282 304.479V305.963Z",
    fill: "#424242"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M397.679 306.878L397.45 307.031V305.546L397.679 305.394V306.878Z",
    fill: "#424242"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M396.728 307.453L396.69 307.491V306.006L396.728 305.968V307.453Z",
    fill: "#424242"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M398.17 306.612L398.132 306.65V305.165L398.17 305.127V306.612Z",
    fill: "#424242"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M396.5 307.598L396.424 307.636V306.151L396.5 306.113V307.598Z",
    fill: "#424242"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M396.285 307.72L396.209 307.758V306.273L396.285 306.235V307.72Z",
    fill: "#424242"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M398.412 306.46L398.374 306.498V305.014H398.412V306.46Z",
    fill: "#424242"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M395.501 308.135L395.463 308.173V306.688L395.501 306.65V308.135Z",
    fill: "#424242"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M394.445 308.746L394.407 308.784V307.299L394.445 307.261V308.746Z",
    fill: "#424242"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M397 307.295L396.886 307.333V305.849L397 305.811V307.295Z",
    fill: "#424242"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M397.952 306.722L397.875 306.798V305.313L397.952 305.237V306.722Z",
    fill: "#424242"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M396.018 307.869L395.751 308.021V306.536L396.018 306.384V307.869Z",
    fill: "#424242"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M394.105 308.97L393.877 309.122V307.6L394.105 307.485V308.97Z",
    fill: "#424242"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M476.057 214.742L348.292 288.529L295 257.787L422.803 184L476.057 214.742Z",
    fill: "url(#paint56_linear_1504_151244)"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M476.054 222.972L348.289 296.76V288.532L476.054 214.744V222.972Z",
    fill: "#FF9800"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M476.054 220.375L348.289 294.124V290.886L476.054 217.137V220.375Z",
    fill: "#CC7900"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M348.292 296.754L295 266.012V257.784L348.292 288.526V296.754Z",
    fill: "#CF7C00"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M322.183 397.199L334.753 404.475L339.477 401.77L326.906 394.494L322.183 397.199Z",
    fill: "url(#paint57_linear_1504_151244)"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M322.183 399.938L334.753 407.214V404.471L322.183 397.195V399.938Z",
    fill: "url(#paint58_linear_1504_151244)"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M330.83 402.228L335.591 399.486V268.405L330.83 271.11V402.228Z",
    fill: "url(#paint59_linear_1504_151244)"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M326.098 399.487L330.822 402.229V271.111L326.098 268.368V399.487Z",
    fill: "url(#paint60_linear_1504_151244)"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M326.098 268.365L330.822 271.108L335.583 268.403L330.822 265.66L326.098 268.365Z",
    fill: "url(#paint61_linear_1504_151244)"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M334.755 407.218L339.477 404.514V401.771L334.755 404.476V407.218Z",
    fill: "#596478"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M288.622 377.848L301.231 385.124L305.955 382.381L293.346 375.105L288.622 377.848Z",
    fill: "url(#paint62_linear_1504_151244)"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M288.622 380.587L301.231 387.862V385.12L288.622 377.844V380.587Z",
    fill: "#2565C4"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M288.622 380.587L301.231 387.862V385.12L288.622 377.844V380.587Z",
    fill: "url(#paint63_linear_1504_151244)"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M297.309 382.839L302.032 380.134V249.054L297.309 251.758V382.839Z",
    fill: "url(#paint64_linear_1504_151244)"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M292.538 380.135L297.3 382.84V251.759L292.538 249.017V380.135Z",
    fill: "url(#paint65_linear_1504_151244)"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M292.538 249.013L297.3 251.756L302.023 249.051L297.3 246.309L292.538 249.013Z",
    fill: "url(#paint66_linear_1504_151244)"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M301.232 387.867L305.954 385.125V382.383L301.232 385.125V387.867Z",
    fill: "#546074"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M458.121 216.294L423.875 236.103L388.562 215.799L422.808 196.028L458.121 216.294Z",
    fill: "#0D0D0D"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M454.609 182.847L423.829 200.599L392.059 182.352L422.839 164.601L454.609 182.847Z",
    fill: "url(#paint67_linear_1504_151244)"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M441.591 190.315L436.867 193.02L405.136 174.773L409.821 172.068L441.591 190.315Z",
    fill: "#9C805F"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M423.847 234.275L392.077 216.028V182.354L423.847 200.6V234.275Z",
    fill: "#F5CB95"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M454.625 216.519L423.845 234.27V200.595L454.625 182.844V216.519Z",
    fill: "url(#paint68_linear_1504_151244)"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M441.594 200.562L436.87 203.266V193.019L441.594 190.314V200.562Z",
    fill: "#705C44"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M452.413 197.356L443.614 202.423V192.976L452.413 187.871V197.356Z",
    fill: "#EBEBEB"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M451.572 190.457L444.867 194.343V193.467L451.572 189.581V190.457Z",
    fill: "#9E9E9E"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M451.572 192.787L444.867 196.673V195.797L451.572 191.911V192.787Z",
    fill: "#9E9E9E"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M451.572 195.11L444.867 198.995V198.119L451.572 194.233V195.11Z",
    fill: "#9E9E9E"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M439.221 217.171L426.727 224.333V223.19L439.221 215.99V217.171Z",
    fill: "#9C8469"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M439.221 221.093L426.727 228.293V227.112L439.221 219.912V221.093Z",
    fill: "#9C8469"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M439.221 223.077L426.727 230.277V229.134L439.221 221.935V223.077Z",
    fill: "#9C8469"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M452.413 203.575L443.614 208.68V204.185L452.413 199.08V203.575Z",
    fill: "#EBEBEB"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M449.217 203.802L448.988 203.954V201.86L449.217 201.708V203.802Z",
    fill: "#424242"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M451.353 202.583L451.124 202.697V200.604L451.353 200.489V202.583Z",
    fill: "#424242"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M446.285 205.476L446.094 205.628V203.534L446.285 203.382V205.476Z",
    fill: "#424242"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M445.746 205.826L445.518 205.941V203.847L445.746 203.732V205.826Z",
    fill: "#424242"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M452.08 202.166L451.699 202.357V200.263L452.08 200.072V202.166Z",
    fill: "#424242"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M449.781 203.462L449.438 203.691V201.597L449.781 201.368V203.462Z",
    fill: "#424242"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M448.422 204.266L448.345 204.304V202.21L448.422 202.172V204.266Z",
    fill: "#424242"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M450.508 203.081L450.394 203.119V201.025L450.508 200.987V203.081Z",
    fill: "#424242"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M448.07 204.487L447.994 204.525V202.431L448.07 202.354V204.487Z",
    fill: "#424242"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M447.764 204.643L447.688 204.719V202.587L447.764 202.549V204.643Z",
    fill: "#424242"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M450.814 202.888L450.738 202.926V200.832L450.814 200.794V202.888Z",
    fill: "#424242"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M446.699 205.254L446.623 205.292V203.198L446.699 203.16V205.254Z",
    fill: "#424242"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M445.22 206.125L445.144 206.163V204.069L445.22 204.031V206.125Z",
    fill: "#424242"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M448.807 204.072L448.693 204.111V202.017L448.807 201.979V204.072Z",
    fill: "#424242"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M450.171 203.268L450.057 203.306V201.212L450.171 201.174V203.268Z",
    fill: "#424242"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M447.385 204.874L447.043 205.065V202.971L447.385 202.78V204.874Z",
    fill: "#424242"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M444.724 206.392L444.381 206.62V204.488L444.724 204.298V206.392Z",
    fill: "#424242"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M423.382 236.599L389.136 256.369L353.823 236.066L388.069 216.295L423.382 236.599Z",
    fill: "#0D0D0D"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M419.87 203.152L389.091 220.904L357.321 202.657L388.1 184.905L419.87 203.152Z",
    fill: "url(#paint69_linear_1504_151244)"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M406.848 210.62L402.124 213.325L370.392 195.078L375.078 192.373L406.848 210.62Z",
    fill: "#9C805F"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M389.096 254.579L357.326 236.332V202.657L389.096 220.904V254.579Z",
    fill: "#F5CB95"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M419.877 236.786L389.098 254.576V220.901L419.877 203.149V236.786Z",
    fill: "url(#paint70_linear_1504_151244)"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M406.838 220.828L402.115 223.571V213.324L406.838 210.619V220.828Z",
    fill: "#705C44"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M417.656 217.664L408.856 222.731V213.283L417.656 208.179V217.664Z",
    fill: "#EBEBEB"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M416.815 210.766L410.11 214.613V213.737L416.815 209.89V210.766Z",
    fill: "#9E9E9E"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M416.815 213.095L410.11 216.942V216.066L416.815 212.219V213.095Z",
    fill: "#9E9E9E"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M416.815 215.416L410.11 219.264V218.388L416.815 214.54V215.416Z",
    fill: "#9E9E9E"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M404.467 237.435L391.973 244.635V243.492L404.467 236.292V237.435Z",
    fill: "#9C8469"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M404.467 241.357L391.973 248.556V247.414L404.467 240.214V241.357Z",
    fill: "#9C8469"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M404.467 243.379L391.973 250.579V249.398L404.467 242.198V243.379Z",
    fill: "#9C8469"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M417.656 223.88L408.857 228.984V224.451L417.656 219.385V223.88Z",
    fill: "#EBEBEB"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M414.458 224.106L414.229 224.22V222.126L414.458 222.012V224.106Z",
    fill: "#424242"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M416.596 222.888L416.368 223.002V220.908L416.596 220.794V222.888Z",
    fill: "#424242"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M411.523 225.78L411.333 225.895V223.801L411.523 223.687V225.78Z",
    fill: "#424242"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M410.99 226.126L410.761 226.24V224.146L410.99 223.994V226.126Z",
    fill: "#424242"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M417.323 222.471L416.942 222.661V220.567L417.323 220.377V222.471Z",
    fill: "#424242"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M415.024 223.767L414.682 223.957V221.863L415.024 221.673V223.767Z",
    fill: "#424242"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M413.665 224.571L413.589 224.609V222.515L413.665 222.477V224.571Z",
    fill: "#424242"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M415.751 223.347L415.637 223.423V221.329L415.751 221.253V223.347Z",
    fill: "#424242"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M413.316 224.753L413.24 224.791V222.697L413.316 222.659V224.753Z",
    fill: "#424242"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M413.014 224.947L412.9 224.985V222.891L413.014 222.853V224.947Z",
    fill: "#424242"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M416.072 223.193L415.957 223.231V221.137L416.072 221.099V223.193Z",
    fill: "#424242"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M411.94 225.559L411.863 225.597V223.503L411.94 223.465V225.559Z",
    fill: "#424242"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M410.463 226.431L410.387 226.469V224.375L410.463 224.299V226.431Z",
    fill: "#424242"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M414.012 224.338L413.936 224.414V222.32L414.012 222.244V224.338Z",
    fill: "#424242"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M415.414 223.572L415.3 223.61V221.516L415.414 221.439V223.572Z",
    fill: "#424242"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M412.631 225.137L412.289 225.365V223.271L412.631 223.043V225.137Z",
    fill: "#424242"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M409.967 226.697L409.625 226.887V224.793L409.967 224.603V226.697Z",
    fill: "#424242"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M385.622 258.045L351.376 277.816L316.064 257.55L350.31 237.779L385.622 258.045Z",
    fill: "#0D0D0D"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M382.113 224.598L351.333 242.35L319.564 224.103L350.343 206.352L382.113 224.598Z",
    fill: "url(#paint71_linear_1504_151244)"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M369.093 232.066L364.369 234.771L332.637 216.524L337.323 213.819L369.093 232.066Z",
    fill: "#9C805F"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M351.337 276.028L319.567 257.781V224.106L351.337 242.353V276.028Z",
    fill: "#F5CB95"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M351.337 276.028L319.567 257.781V224.106L351.337 242.353V276.028Z",
    fill: "url(#paint72_linear_1504_151244)"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M382.115 258.234L351.336 276.024V242.349L382.115 224.598V258.234Z",
    fill: "url(#paint73_linear_1504_151244)"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M369.084 242.275L364.36 245.017V234.77L369.084 232.065V242.275Z",
    fill: "#705C44"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M379.896 239.113L371.097 244.18V234.732L379.896 229.628V239.113Z",
    fill: "#EBEBEB"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M379.055 232.215L372.351 236.063V235.186L379.055 231.339V232.215Z",
    fill: "#9E9E9E"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M379.055 234.544L372.351 238.392V237.515L379.055 233.668V234.544Z",
    fill: "#9E9E9E"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M379.055 236.865L372.351 240.751V239.875L379.055 235.989V236.865Z",
    fill: "#9E9E9E"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M366.731 258.923L354.236 266.085V264.942L366.731 257.742V258.923Z",
    fill: "#9C8469"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M366.731 262.807L354.236 270.007V268.864L366.731 261.664V262.807Z",
    fill: "#9C8469"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M366.731 264.828L354.236 272.028V270.847L366.731 263.686V264.828Z",
    fill: "#9C8469"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M379.896 245.328L371.097 250.433V245.938L379.896 240.833V245.328Z",
    fill: "#EBEBEB"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M376.705 245.55L376.476 245.664V243.57L376.705 243.456V245.55Z",
    fill: "#424242"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M378.836 244.33L378.608 244.445V242.351L378.836 242.236V244.33Z",
    fill: "#424242"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M373.768 247.224L373.578 247.376V245.244L373.768 245.13V247.224Z",
    fill: "#424242"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M373.232 247.574L373.004 247.689V245.595L373.232 245.48V247.574Z",
    fill: "#424242"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M379.565 243.914L379.185 244.105V242.011L379.565 241.82V243.914Z",
    fill: "#424242"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M377.267 245.211L376.924 245.402V243.308L377.267 243.117V245.211Z",
    fill: "#424242"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M375.908 246.013L375.831 246.051V243.957L375.908 243.919V246.013Z",
    fill: "#424242"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M377.994 244.828L377.88 244.866V242.772L377.994 242.734V244.828Z",
    fill: "#424242"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M375.556 246.195L375.479 246.272V244.14L375.556 244.102V246.195Z",
    fill: "#424242"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M375.25 246.39L375.174 246.428V244.334L375.25 244.296V246.39Z",
    fill: "#424242"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M378.3 244.636L378.224 244.674V242.58L378.3 242.542V244.636Z",
    fill: "#424242"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M374.184 247.001L374.108 247.039V244.945L374.184 244.907V247.001Z",
    fill: "#424242"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M372.706 247.874L372.63 247.912V245.818L372.706 245.742V247.874Z",
    fill: "#424242"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M376.293 245.82L376.178 245.858V243.764L376.293 243.688V245.82Z",
    fill: "#424242"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M377.656 245.015L377.542 245.053V242.959L377.656 242.883V245.015Z",
    fill: "#424242"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M374.874 246.618L374.531 246.809V244.715L374.874 244.486V246.618Z",
    fill: "#424242"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M372.21 248.14L371.867 248.33V246.236L372.21 246.046V248.14Z",
    fill: "#424242"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M412.441 277.028L396.127 320.243L394.792 319.751L392.152 287.134L411.063 276.578L412.441 277.028Z",
    fill: "#3C2415"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M415.085 309.684L396.131 320.239L393.492 287.58L412.445 277.025L415.085 309.684Z",
    fill: "#603913"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M413.59 306.312L396.974 315.558L394.634 286.927L411.292 277.683L413.59 306.312Z",
    fill: "url(#paint74_linear_1504_151244)"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M456.981 318.172C455.525 317.381 452.255 319.095 452.255 319.095L457.376 330.206C457.376 330.206 462.282 326.491 461.772 322.5C461.616 321.862 457.69 318.44 456.981 318.172Z",
    fill: "#0D0D0D"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M462.543 311.166C462.543 311.166 459.232 314.997 458.576 316.297C455.163 321.015 459.606 323.813 463.003 322.058C465.211 320.916 470.301 318.559 470.301 318.559L462.543 311.166Z",
    fill: "#FBC896"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M465.973 305.641C465.973 305.641 462.536 307.268 461.706 311.063C460.918 314.816 464.09 318.097 467.734 318.761C473.22 319.758 474.639 313.857 474.639 313.857L465.973 305.641Z",
    fill: "#7D261A"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M465.973 305.641C465.973 305.641 462.536 307.268 461.706 311.063C460.918 314.816 464.09 318.097 467.734 318.761C473.22 319.758 474.639 313.857 474.639 313.857L465.973 305.641Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M457.655 277.269C457.655 277.269 468.498 273.035 470.736 285.402C473.199 299.128 476.262 308.039 476.119 311.043C476.102 311.89 475.602 313.828 474.448 314.779C469.616 319.004 462.161 311.193 463.768 308.515L465.016 307.057C465.016 307.057 462.081 302.383 461.289 299.912C460.454 297.482 457.697 277.228 457.697 277.228L457.655 277.269Z",
    fill: "#912018"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M453.362 273.717C453.259 274.689 454.159 278.137 454.159 278.137L453.614 282.361L446.296 284.716L440.035 284.594L437.754 283.025C437.754 283.025 438.933 278.644 438.288 272.956C438.004 272.4 443.942 267.519 443.942 267.519L449.013 270.456C449.013 270.456 453.381 272.743 453.278 273.715L453.362 273.717Z",
    fill: "#FBC896"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M433.463 255.121C431.513 258.132 432.914 261.717 432.767 262.773C431.416 267.405 433.653 273.335 435.357 274.342C436.479 274.999 438.384 274.317 438.384 274.317C438.384 274.317 443.088 272.334 444.479 269.989C445.667 269.42 442.595 258.9 442.595 258.9C442.595 258.9 434.192 254.416 433.547 255.123L433.463 255.121Z",
    fill: "#FBC896"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M454.476 272.595C450.86 276.928 445.002 275.585 443.583 275.05C442.165 274.514 442.844 267.751 438.941 265.261C437.447 264.3 437.278 266.457 436.076 265.628C435.454 265.193 435.532 263.331 435.257 260.234C434.978 257.307 431.49 255.079 434.925 251.377C437.072 249.09 448.493 241.098 456.957 255.323C461.392 262.821 455.207 271.72 454.477 272.552L454.476 272.595Z",
    fill: "url(#paint75_linear_1504_151244)"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M454.159 278.097C445.467 284.109 437.797 282.985 437.797 282.985C437.797 282.985 426.885 290.733 423.995 294.488C416.319 304.417 423.049 321.36 422.598 322.961C422.189 324.52 422.877 328.006 422.877 328.006L423.709 332.765L442.161 332.787L455.36 324.11L460.974 305.756L462.445 303.583C462.445 303.583 464.537 299.77 466.202 292.053C467.813 284.885 463.977 274.731 454.203 278.013L454.159 278.097Z",
    fill: "url(#paint76_linear_1504_151244)"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M426.794 331.726C432.15 332.975 437.442 313.852 437.442 313.852L463.832 301.283C463.832 301.283 457.719 321.575 457.087 328.084C455.804 329.203 442.905 337.547 442.905 337.547L429.723 338.898L423.03 332.923C423.03 332.923 423.321 326.661 424.482 323.169C424.482 323.169 424.718 330.415 426.794 331.769L426.794 331.726Z",
    fill: "#2E62B1"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M439.457 314.314C439.457 314.314 442.627 298.369 437.128 291.528C434.337 288.085 427.597 291.003 427.597 291.003C429.381 287.904 432.634 287.078 432.634 287.078C432.634 287.078 438.206 283.715 442.585 289.771C447.578 296.687 444.51 311.661 444.51 311.661L439.414 314.356L439.457 314.314Z",
    fill: "#2E62B1"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M456.747 306.306C456.747 306.306 468.584 283.5 454.147 278.094C454.147 278.094 456.025 276.606 458.405 277.457C470.619 282.608 461.802 303.61 461.802 303.61L456.706 306.263L456.747 306.306Z",
    fill: "#2E62B1"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M461.658 433.404C461.658 433.404 463.096 441.521 458.689 441.223C454.281 440.925 451.058 433.79 451.058 433.79C451.058 433.79 444.125 429.377 444.626 425.279C444.696 421.681 452.473 423.781 452.473 423.781L461.615 433.446L461.658 433.404Z",
    fill: "#3C2415"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M461.333 349.335C461.333 349.335 461.71 366.578 460.149 386.197C459.812 390.552 463.996 395.843 464.165 402.241C464.261 405.885 464.119 415.326 463.843 422.985C463.605 428.697 463.514 433.354 462.243 433.88C453.631 435.744 449.308 431.128 449.192 426.341C449.075 421.553 448.508 405.45 447.478 395.774C442.937 385.098 440.021 357.981 440.021 357.981L461.333 349.335Z",
    fill: "url(#paint77_linear_1504_151244)"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M439.358 443.169C439.358 443.169 440.812 450.481 436.594 451.246C423.664 452.56 414.174 449.96 411.599 448.385C410.052 447.932 405.681 441.494 411.117 440.753C416.723 439.974 425.54 438.325 425.54 438.325L439.358 443.169Z",
    fill: "#3C2415"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M457.085 328.083C457.085 328.083 439.753 337.399 434.165 337.289C427.173 338.042 424.792 335.116 423.436 331.405C417.027 358.17 423.202 394.88 423.202 394.88C423.202 394.88 427.125 422.144 422.045 438.984C423.26 443.496 433.508 448.186 439.473 444.11C443.946 441.064 442.541 405.422 439.2 400.021L445.117 361.854C445.117 361.854 454.847 358.656 459.882 352.699C464.916 346.742 457.127 328.041 457.127 328.041L457.085 328.083Z",
    fill: "url(#paint78_linear_1504_151244)"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M398.017 309.521C399.102 307.763 398.495 304.448 398.495 304.448C398.495 304.448 399.417 304.593 399.847 304.094C400.277 303.594 400.934 300.092 399.097 299.421C397.637 298.884 394.681 301.706 394.681 301.706L393.267 300.958L392.998 297.523C385.588 302.417 390.812 310.439 391.163 311.801C391.437 312.865 392.508 313.987 392.508 313.987C392.508 313.987 397.16 310.351 398.06 309.479L398.017 309.521Z",
    fill: "#0D0D0D"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M410.357 317.13C410.357 317.13 405.024 314.739 398.354 309.738C395.372 307.478 391.621 312.317 392.676 314.243C397.584 321.157 404.163 326.494 404.163 326.494L410.399 317.131L410.357 317.13Z",
    fill: "#FBC896"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M416.173 320.12C416.173 320.12 413.266 316.21 409.055 316.593C404.845 316.934 402.664 320.999 402.92 325.07C403.374 331.981 410.809 332.211 410.809 332.211L416.215 320.121L416.173 320.12Z",
    fill: "#B42318"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M436.271 294.298C441.664 297.961 434.534 312.219 434.534 312.219C434.534 312.219 425.815 332.461 421 333.679C416.226 334.899 409.119 332.938 406.956 329.635C405.854 327.962 409.786 318.172 415.336 320.229C416.397 317.582 421.602 302.904 421.602 302.904C421.602 302.904 426.481 287.669 436.271 294.298Z",
    fill: "url(#paint79_linear_1504_151244)"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M415.29 320.232C415.29 320.232 417.39 326.752 416.204 327.237C413.881 325.667 415.29 320.232 415.29 320.232Z",
    fill: "#B42318"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M415.29 320.232C415.29 320.232 417.39 326.752 416.204 327.237C413.881 325.667 415.29 320.232 415.29 320.232Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M407.987 296.109C408.14 296.692 408.18 297.297 408.105 297.891C408.03 298.484 407.842 299.053 407.55 299.567C407.259 300.08 406.871 300.526 406.408 300.881C405.945 301.236 405.416 301.492 404.852 301.635L404.36 299.757C404.808 299.648 405.218 299.423 405.551 299.102C405.873 298.793 406.104 298.397 406.219 297.957C406.331 297.505 406.327 297.028 406.207 296.572C406.088 296.117 405.857 295.697 405.537 295.354C405.221 295.024 404.824 294.787 404.391 294.67C403.936 294.555 403.464 294.554 403.015 294.667C402.566 294.781 402.153 295.006 401.812 295.322C401.49 295.629 401.26 296.022 401.146 296.46C401.066 296.768 401.043 297.09 401.079 297.409C400.315 297.141 399.623 296.682 399.068 296.074C398.513 295.465 398.112 294.727 397.903 293.927L402.526 292.758C403.091 292.615 403.68 292.588 404.259 292.679C404.839 292.77 405.399 292.977 405.906 293.288C406.413 293.599 406.858 294.009 407.215 294.493C407.572 294.977 407.834 295.526 407.987 296.109Z",
    fill: "black"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M407.003 292.353L406.467 290.305L409.771 289.469L407.003 292.353Z",
    fill: "black"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M406.198 289.281L406.466 290.305L403.161 291.141C403.031 291.174 402.895 291.18 402.761 291.159C402.627 291.138 402.498 291.09 402.381 291.019C402.264 290.947 402.161 290.852 402.079 290.741C401.996 290.629 401.936 290.502 401.9 290.368L401.632 289.344L404.937 288.508C405.067 288.475 405.203 288.469 405.337 288.49C405.471 288.511 405.6 288.559 405.717 288.63C405.834 288.702 405.936 288.797 406.019 288.908C406.101 289.02 406.162 289.147 406.197 289.281",
    fill: "black"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M404.829 297.934C404.661 298.237 404.398 298.434 404.039 298.527L404.03 298.529C403.667 298.621 403.337 298.574 403.039 298.387C402.779 298.222 402.583 297.968 402.487 297.672C402.469 297.624 402.454 297.574 402.441 297.522C402.339 297.133 402.372 296.786 402.541 296.482C402.71 296.177 402.977 295.978 403.339 295.886C403.703 295.795 404.033 295.842 404.331 296.029C404.629 296.216 404.829 296.504 404.931 296.893C405.032 297.283 404.998 297.63 404.829 297.934Z",
    fill: "#FF9800"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M460.454 448.704C447.6 456.154 426.752 456.154 413.897 448.704C401.042 441.255 401.042 429.141 413.897 421.692C426.752 414.242 447.6 414.242 460.454 421.692C473.309 429.141 473.309 441.219 460.454 448.704Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 59.7553,
    y: 0.501723,
    width: 34.5499,
    height: 34.5499,
    rx: 17.2749,
    fill: "white"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9221 14.5137V22.8047M65.7766 18.6592H74.0677",
    stroke: "#FFD700",
    strokeWidth: 1.18444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4003 20.6333C87.4003 21.3075 87.2711 21.9751 87.02 22.598C86.7688 23.2208 86.4008 23.7868 85.9368 24.2634C85.4728 24.7401 84.922 25.1181 84.3158 25.3759C83.7096 25.6338 83.06 25.7663 82.4039 25.766V23.5948C82.9231 23.6 83.4348 23.4681 83.8901 23.2117C84.3294 22.9647 84.6942 22.5985 84.9447 22.1529C85.1956 21.6932 85.3274 21.1749 85.3274 20.6478C85.3274 20.1207 85.1956 19.6025 84.9447 19.1428C84.6945 18.6976 84.3296 18.3321 83.8901 18.0866C83.4279 17.8366 82.9135 17.706 82.3912 17.706C81.869 17.706 81.3546 17.8366 80.8924 18.0866C80.4544 18.3306 80.0908 18.6946 79.8418 19.1382C79.6661 19.4497 79.5494 19.7927 79.4979 20.1489C78.7405 19.6486 78.1175 18.9609 77.6861 18.1488C77.2547 17.3367 77.0287 16.4262 77.0288 15.501H82.4039C83.06 15.5006 83.7096 15.6331 84.3158 15.8909C84.922 16.1487 85.4728 16.5267 85.9368 17.0033C86.4008 17.4799 86.7688 18.0458 87.0199 18.6686C87.2711 19.2915 87.4003 19.9591 87.4003 20.6333Z",
    fill: "#FFD700"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4004 16.2906V13.9219H91.2421L87.4004 16.2906Z",
    fill: "#FFD700"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4356 21.7468C83.1662 22.0284 82.8229 22.1704 82.4058 22.1728H82.3954C81.9733 22.1728 81.6266 22.0308 81.3552 21.7468C81.1187 21.4966 80.9774 21.1676 80.957 20.8194C80.9521 20.7626 80.9496 20.7048 80.9496 20.645C80.9496 20.1949 81.0853 19.8278 81.3567 19.5438C81.6281 19.2597 81.9748 19.1175 82.3969 19.1172C82.8189 19.1172 83.1657 19.2594 83.4371 19.5438C83.7085 19.8282 83.8442 20.1952 83.8442 20.645C83.8432 21.0961 83.707 21.4634 83.4356 21.7468Z",
    fill: "#FFD700"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1329 10.5055C88.1329 10.2402 87.952 10.0245 87.7297 10.0245C87.5073 10.0245 87.3265 10.2402 87.3265 10.5055C87.3265 10.5919 87.3459 10.6729 87.3795 10.743L85.5801 11.6018L84.8892 9.95332C85.1061 9.82103 85.255 9.55193 85.255 9.24196C85.255 8.8016 84.9547 8.44336 84.5856 8.44336C84.2165 8.44336 83.9162 8.80163 83.9162 9.24196C83.9162 9.55193 84.0651 9.821 84.2819 9.95332L83.5911 11.6018L81.782 10.7384C81.8142 10.6693 81.8326 10.59 81.8326 10.5055C81.8326 10.2402 81.6518 10.0245 81.4294 10.0245C81.2071 10.0245 81.0262 10.2402 81.0262 10.5055C81.0262 10.7004 81.1241 10.8683 81.2641 10.9438L82.1699 13.6213C82.201 13.7132 82.2757 13.7733 82.3587 13.7733H86.8395C86.9233 13.7733 86.9986 13.712 87.0291 13.6189L87.91 10.9352C88.0419 10.8561 88.1329 10.6934 88.1329 10.5055Z",
    fill: "#FFD700"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 59.7553,
    y: 0.501723,
    width: 34.5499,
    height: 34.5499,
    rx: 17.2749,
    stroke: "#FAC515",
    strokeWidth: 1.00345
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0303 56.8614C74.8409 56.8614 73.066 58.6363 73.066 60.8257C73.066 63.0151 74.8409 64.7899 77.0303 64.7899C79.2197 64.7899 80.9945 63.0151 80.9945 60.8257C80.9945 58.6363 79.2197 56.8614 77.0303 56.8614ZM76.287 35.5537L76.287 60.8257L77.7736 60.8257L77.7736 35.5537L76.287 35.5537Z",
    fill: "#FAC515"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1504_151244",
    x1: 339.52,
    y1: 59.7844,
    x2: 371.338,
    y2: 140.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98A2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1504_151244",
    x1: 438.248,
    y1: 114.541,
    x2: 443.422,
    y2: 129.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A2E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA530C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1504_151244",
    x1: 320.062,
    y1: 45.1811,
    x2: 436.209,
    y2: 115.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A2E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C2F0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1504_151244",
    x1: 443.033,
    y1: 132.482,
    x2: 416.932,
    y2: 195.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A2E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79009"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1504_151244",
    x1: 292.727,
    y1: 54.5385,
    x2: 438.979,
    y2: 142.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787676"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1504_151244",
    x1: 309.276,
    y1: 77.2434,
    x2: 341.095,
    y2: 157.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98A2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1504_151244",
    x1: 380.306,
    y1: 117.918,
    x2: 380.306,
    y2: 132.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1504_151244",
    x1: 397.829,
    y1: 127.575,
    x2: 397.829,
    y2: 142.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1504_151244",
    x1: 295.368,
    y1: 70.1885,
    x2: 295.368,
    y2: 83.8145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1504_151244",
    x1: 363.566,
    y1: 108.251,
    x2: 363.566,
    y2: 122.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1504_151244",
    x1: 346.843,
    y1: 98.5908,
    x2: 346.843,
    y2: 112.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1504_151244",
    x1: 330.108,
    y1: 88.9258,
    x2: 330.108,
    y2: 103.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1504_151244",
    x1: 313.371,
    y1: 79.2646,
    x2: 313.371,
    y2: 93.5458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1504_151244",
    x1: 408,
    y1: 132,
    x2: 413.174,
    y2: 146.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A2E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA530C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1504_151244",
    x1: 289.849,
    y1: 62.6401,
    x2: 405.981,
    y2: 133.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A2E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C2F0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1504_151244",
    x1: 333,
    y1: 13,
    x2: 321.5,
    y2: 161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00585336,
    stopColor: "#DC6803"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC6803"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1504_151244",
    x1: 280,
    y1: 82.5,
    x2: 314.5,
    y2: 104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E49400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1504_151244",
    x1: 372,
    y1: 37,
    x2: 320.5,
    y2: 115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A2E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC6803"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1504_151244",
    x1: 270,
    y1: 90,
    x2: 307.5,
    y2: 110.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#794100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC6803"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1504_151244",
    x1: 230.5,
    y1: 84,
    x2: 257.5,
    y2: 154.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#575757"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1504_151244",
    x1: 23.5314,
    y1: 193.228,
    x2: 20.5402,
    y2: 211.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42307D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#513B8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1504_151244",
    x1: 23.5314,
    y1: 193.228,
    x2: 20.5402,
    y2: 211.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A2E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89370C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1504_151244",
    x1: 156.178,
    y1: 116.202,
    x2: 26.678,
    y2: 194.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A2E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C2F0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1504_151244",
    x1: 40.1779,
    y1: 219.202,
    x2: 30.1779,
    y2: 275.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A2E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC6803"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1504_151244",
    x1: 55.0809,
    y1: 177.604,
    x2: 55.0809,
    y2: 193.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567708,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1504_151244",
    x1: 35.5579,
    y1: 188.399,
    x2: 35.5579,
    y2: 205.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567708,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1504_151244",
    x1: 149.639,
    y1: 124.363,
    x2: 149.639,
    y2: 139.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567708,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1504_151244",
    x1: 73.7063,
    y1: 166.846,
    x2: 73.7063,
    y2: 182.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567708,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1504_151244",
    x1: 92.3444,
    y1: 156.055,
    x2: 92.3444,
    y2: 171.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567708,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1504_151244",
    x1: 110.98,
    y1: 145.267,
    x2: 110.98,
    y2: 161.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567708,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1504_151244",
    x1: 129.6,
    y1: 134.477,
    x2: 129.6,
    y2: 150.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567708,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1504_151244",
    x1: 186.678,
    y1: 126.702,
    x2: 23.678,
    y2: 224.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787676"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1504_151244",
    x1: 168.178,
    y1: 152.702,
    x2: 129.678,
    y2: 245.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98A2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1504_151244",
    x1: 89.0678,
    y1: 197.363,
    x2: 89.0678,
    y2: 213.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1504_151244",
    x1: 69.5426,
    y1: 208.149,
    x2: 69.5426,
    y2: 225.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1504_151244",
    x1: 183.628,
    y1: 144.118,
    x2: 183.628,
    y2: 159.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1504_151244",
    x1: 107.696,
    y1: 186.599,
    x2: 107.696,
    y2: 202.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1504_151244",
    x1: 126.318,
    y1: 175.81,
    x2: 126.318,
    y2: 191.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1504_151244",
    x1: 144.956,
    y1: 165.022,
    x2: 144.956,
    y2: 180.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1504_151244",
    x1: 163.575,
    y1: 154.234,
    x2: 163.575,
    y2: 170.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1504_151244",
    x1: 57.1779,
    y1: 212.702,
    x2: 54.1779,
    y2: 230.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A2E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89370C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1504_151244",
    x1: 189.816,
    y1: 135.679,
    x2: 60.3278,
    y2: 214.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A2E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C2F0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1504_151244",
    x1: 434.805,
    y1: 239.505,
    x2: 430.305,
    y2: 239.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98A2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1504_151244",
    x1: 454.657,
    y1: 322.913,
    x2: 472.017,
    y2: 322.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1504_151244",
    x1: 454.676,
    y1: 325.65,
    x2: 467.305,
    y2: 325.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1504_151244",
    x1: 468.332,
    y1: 258.857,
    x2: 463.832,
    y2: 258.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475467"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1504_151244",
    x1: 463.567,
    y1: 258.839,
    x2: 459.103,
    y2: 258.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98A2B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1504_151244",
    x1: 458.607,
    y1: 191.82,
    x2: 468.107,
    y2: 191.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1504_151244",
    x1: 435.5,
    y1: 260.5,
    x2: 318,
    y2: 339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE7D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1504_151244",
    x1: 425.976,
    y1: 233.88,
    x2: 398.989,
    y2: 250.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1BF92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEC591"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1504_151244",
    x1: 453.332,
    y1: 254.077,
    x2: 429.783,
    y2: 268.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1BF92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEC591"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1504_151244",
    x1: 425.368,
    y1: 246.037,
    x2: 384.756,
    y2: 271.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1BF92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD6A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1504_151244",
    x1: 438.963,
    y1: 261.347,
    x2: 395.498,
    y2: 290.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6966D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981189,
    stopColor: "#D1AD7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1504_151244",
    x1: 386.5,
    y1: 283.5,
    x2: 341,
    y2: 312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1BF92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD6A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1504_151244",
    x1: 342.155,
    y1: 306.451,
    x2: 342.155,
    y2: 343.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5B081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5CB95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1504_151244",
    x1: 402,
    y1: 293,
    x2: 355.5,
    y2: 342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6966D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981189,
    stopColor: "#D1AD7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1504_151244",
    x1: 439.663,
    y1: 195.027,
    x2: 322.163,
    y2: 273.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE7D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1504_151244",
    x1: 322.113,
    y1: 399.425,
    x2: 339.434,
    y2: 399.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1504_151244",
    x1: 322.132,
    y1: 402.145,
    x2: 334.722,
    y2: 402.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1504_151244",
    x1: 335.792,
    y1: 335.389,
    x2: 331.291,
    y2: 335.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C88A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1504_151244",
    x1: 331.02,
    y1: 335.371,
    x2: 326.556,
    y2: 335.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98A2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1504_151244",
    x1: 326.06,
    y1: 268.352,
    x2: 335.56,
    y2: 268.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1504_151244",
    x1: 288.553,
    y1: 380.055,
    x2: 305.912,
    y2: 380.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1504_151244",
    x1: 288.572,
    y1: 382.794,
    x2: 301.2,
    y2: 382.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1504_151244",
    x1: 302.231,
    y1: 316.018,
    x2: 297.767,
    y2: 316.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C88A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1504_151244",
    x1: 297.5,
    y1: 316,
    x2: 293,
    y2: 316.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98A2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1504_151244",
    x1: 292.5,
    y1: 249,
    x2: 302,
    y2: 249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1504_151244",
    x1: 441.692,
    y1: 168.592,
    x2: 401.079,
    y2: 194.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1BF92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD6A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1504_151244",
    x1: 455.287,
    y1: 183.905,
    x2: 411.842,
    y2: 213.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6966D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981189,
    stopColor: "#D1AD7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1504_151244",
    x1: 406.953,
    y1: 188.896,
    x2: 366.341,
    y2: 214.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1BF92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD6A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1504_151244",
    x1: 420.539,
    y1: 204.211,
    x2: 377.094,
    y2: 233.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6966D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981189,
    stopColor: "#D1AD7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1504_151244",
    x1: 369.196,
    y1: 210.343,
    x2: 328.583,
    y2: 235.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1BF92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD6A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1504_151244",
    x1: 335.452,
    y1: 224.106,
    x2: 335.452,
    y2: 276.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5B081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5CB95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1504_151244",
    x1: 382.777,
    y1: 225.659,
    x2: 339.332,
    y2: 255.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6966D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981189,
    stopColor: "#D1AD7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1504_151244",
    x1: 410.861,
    y1: 278.742,
    x2: 397.861,
    y2: 314.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAECF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_1504_151244",
    x1: 442.361,
    y1: 247.742,
    x2: 450.861,
    y2: 274.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_1504_151244",
    x1: 455.361,
    y1: 279.242,
    x2: 426.861,
    y2: 330.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#912018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283439,
    stopColor: "#B42318"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_1504_151244",
    x1: 451.861,
    y1: 359.742,
    x2: 455.861,
    y2: 429.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E4683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490258,
    stopColor: "#2565C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_1504_151244",
    x1: 441.539,
    y1: 327.736,
    x2: 439.229,
    y2: 445.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F62AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2565C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_1504_151244",
    x1: 430,
    y1: 296.5,
    x2: 418.361,
    y2: 335.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33684,
    stopColor: "#B42318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04438"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIllustrator);
export default __webpack_public_path__ + "static/media/ProductIllustrator.9a82d678bcd73f92ec7535952c0ca696.svg";
export { ForwardRef as ReactComponent };